import { LOCALES } from '../../utils/i18n/constants'

export default {
  [LOCALES.ITALIAN]: {
    't_aas': 'Tutte le aree',
    't_parent_fund': '(IT Parent fund)',
    't_account_locked': 'Account bloccato',
    't_action': 'Azione',
    't_action_error_message': 'Correggere i problemi evidenziati in rosso',
    't_action_excel': 'SIERA Piano D\'Azioni.xlsx',
    't_action_pdf': 'SIERA Piano D\'Azioni.pdf',
    't_action_plan': 'Piano d\'azione',
    't_horizontal_artificial_areas': 'IT Horizontal artificial areas',
    't_vertical_artificial_areas': 'IT Vertical artificial areas',
    't_generic_number_message': 'IT {field} must be a number',
    't_generic_positivenumber_message': 'IT {field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'IT Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'IT Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'IT Must be before the year the asset was built (see Asset Details)',
    't_action_completion_dates': 'Il completamento dell\'azione è in scadenza',
    't_actions': 'Azioni',
    't_actions_under_review': 'Azioni in esame',
    't_actual': 'Effettivo',
    't_reports_resource_consumption_not_found_msg': 'IT {areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': 'IT {areas} cannot be empty.',
    't_totalweight_not_found_msg': 'IT {areas} cannot be empty.',
    't_startdate_not_found_msg': 'IT {areas} cannot be empty.',
    't_enddate_not_found_msg': 'IT {areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'IT Sustainable Weight',
    't_reports_totalweight_not_found': 'IT Total Weight',
    't_reports_startdate_not_found': 'IT Start Date',
    't_reports_enddate_not_found': 'IT End Date',
    't_biodiversity_extended': 'IT Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_occupancy_extended': 'IT Track the proportion of lettable floor area occupied over time.',
    't_planning_permission_extended': 'IT Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_fossil_fuel_exposure_extended_edit_data': 'IT Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_ped_extended': 'IT Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_gav_extended': 'IT Track the gross value of the asset.',
    't_waste_contracts_extended': 'IT Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_not_covered': 'Non coperto',
    't_report_data_checklist': 'IT Report data checklist',
    't_planning_permission': 'IT Planning Permission',
    't_periodic_reporting_data': 'IT Periodic reporting data',
    't_waste_contracts': 'IT Waste Contracts',
    't_report_data_checklist_info': 'IT Select a reporting framework to highlight data readiness issues.',
    't_resource_consumption_extended': 'IT If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_grey': 'Non coperto',
    't_add_action': 'Aggiungi azione',
    't_add_an_action': 'Aggiungi un\'azione',
    't_no_action_data': 'Non ci sono azioni da visualizzare',
    't_add_action_title': 'Aggiungi titolo azione',
    't_add_date': 'Aggiungi data',
    't_add_note': 'Aggiungi nota',
    't_add_note_description': 'Aggiungere una nota per spiegare tale varianza nel consumo di energia da parte dei target concordati',
    't_agreed': 'Accolta',
    't_agreed_actions': 'Azioni concordate',
    't_asset_agree_actions': 'IT Agreed actions',
    't_all': 'Tutti',
    't_all_actions': 'Tutte le azioni',
    't_alu': 'Tutte le utenze',
    't_api_email_error': 'Email utente non trovata',
    't_applicable': 'Valido',
    't_applicable_actions': 'Azioni applicabili',
    't_approved': 'Approvato',
    't_apr': 'Apr',
    't_april': 'Aprile',
    't_assets_missing_performance_targets': 'Le risorse mancano di obiettivi di rendimento',
    't_asset_summary': 'Riepilogo beni',
    't_assets': 'Risorsa',
    't_asset_s': 'Risorsas',
    't_aug': 'Ago',
    't_august': 'Agosto',
    't_auto_meter_readings': 'Letture automatiche dei contatori (AMR)',
    't_auto_system_upgrades': 'Aggiornamenti/sostituzioni del sistema di automazione',
    't_back_sign_in': 'Torna a Accedi',
    't_biodiversity': 'Biodiversità',
    't_break': 'interrompere',
    't_email_hint': 'IT Recipients (separate multiple email addresses with commas)',
    't_blue': 'Tutti i dati raccolti',
    't_btn_enter': 'Inserisci dati',
    't_btn_request': 'Richiedi dati',
    't_building_manager': 'Responsabile Edificio',
    't_building_performance': 'Prestazioni dell\'edificio',
    't_cancel': 'Annulla',
    't_capital_non_recover': 'Capitale - Non recuperabile',
    't_capital_recover': 'Capitale - Recuperabile',
    't_carbon': 'Carbonio',
    't_cbx_label_all': 'Seleziona tutti',
    't_certifications': 'Certificazioni',
    't_certificates': 'IT Certificates',
    't_change': 'Modifica',
    't_change_password': 'Modifica password',
    't_check_all_completed': 'Segna tutte come completate',
    'close.without.save': 'Uscire senza salvare?',
    't_commercial_event': 'Evento commerciale',
    't_commercial_events': 'Eventi commerciali',
    't_commonareas': 'Ambienti comuni',
    't_community_engagement': 'Impegno nella comunità',
    't_complete_by': 'Completa entro',
    't_complete': 'Completi',
    't_completed': 'Completata',
    't_completed_action': 'Azione completata',
    't_completed_actions': 'Azioni completate',
    't_completion': 'Completamento',
    't_completion_date': 'Data di completamento',
    't_composting_landscape': 'Rifiuti compostabili e/o rifiuti alimentari',
    't_confirm_new_password': 'Conferma nuova password',
    't_contact_evora': 'Contatta EVORA',
    't_contact_problem_msg_1': 'Problemi di accesso?',
    't_contact_problem_msg_2': 'Hai un problema?',
    't_contact_us': 'Contattaci',
    't_content': 'Indice',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cooling_tower': 'Torre di raffreddamento',
    't_cost': 'Costo',
    't_cost_type': 'Tipologia costi',
    't_create_password': 'Crea nuova password',
    't_current': 'Attuale',
    't_current_password': 'Password attuale',
    't_consumption': 'Consumo',
    't_add_action_plan_in_bulk': 'IT Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'IT Edit action plans in bulk',
    't_data': 'IT Data',
    't_no_records_found': 'IT No records found',
    't_dashboard': 'Pannello',
    't_dashboard_pdf': 'SIERA Dashboard.pdf',
    't_data_quality': 'Qualità dei dati',
    't_data_quality_two_lines': 'Qualità {br} dei dati',
    't_date': 'Data',
    't_dec': 'Dic',
    't_december': 'Dicembre',
    't_delete': 'Elimina',
    't_delete_action_title': 'Elimina azione',
    't_delete_confirmation': 'Sei sicuro?',
    't_detail': 'Dettaglio',
    't_district_cooling': 'Teleraffreddamento',
    't_districtcooling': 'Teleraffreddamento',
    't_district_heating': 'Teleriscaldamento',
    't_districtheating': 'Teleriscaldamento',
    't_dq_data_entered': 'Dati inseriti',
    't_dq_data_provided_on': 'Forniti il',
    't_dq_data_requested': 'Dati richiesti',
    't_dq_data_requested_on': 'Richiesti il',
    't_done': 'Fatto',
    't_drip_irrigation': 'Irrigazione a goccia/intelligente',
    't_drought_tolerant_landscaping': 'Paesaggistica a prova di siccità / autoctona',
    't_due_date': 'Termine',
    't_edit': 'Modifica',
    't_electricity': 'Elettricità',
    't_email': 'Indirizzo email',
    't_email_reset': 'Riceverai via email i dettagli per il login.',
    't_email_notifications': 'Notifiche email',
    't_energy': 'Energia',
    't_energyintensity': 'IT Energy Intensity',
    't_energy_rating': 'Classe energetica',
    't_EPC_rating': 'IT EPC rating',
    't_Asset_EPC_rating': 'IT EPC ratings',
    't_english': 'Inglese',
    't_enter_data': 'Inserisci dati',
    't_enter_current_password': 'Inserire la password attuale',
    't_error': 'Spiacenti, non puoi accedere',
    't_error_account_locked': 'L\'account è stato bloccato per i troppi tentativi di accesso falliti.',
    't_error_account_revoked': 'Un amministratore ha revocato il tuo accesso a questo account.',
    't_error_ok': 'OK',
    't_error_back_to_homepage': 'Torna alla homepage',
    't_error_request_400': 'Si è verificato un errore durante l\'elaborazione della richiesta.',
    't_error_request_401': 'Non sei in possesso dell\'autorizzazione sufficiente per accedere alla risorsa',
    't_page_not_found': 'IT Page not found',
    't_page_not_found_reason': 'IT You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'IT There was a problem logging in.',
    't_page_auth_error_reason': 'IT There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'IT Try logging in again',
    't_error_try_msg': 'Riprova tra qualche ora.',
    't_error_user_password': 'Email/password errata, riprova.',
    't_error_user_username': 'L\'ID e-mail è vuoto o non valido.',
    't_error_user_no_access': 'Email/password errata, riprova.',
    't_error_user_account_locked': 'L\'account è bloccato per i successivi {lockedDuration} secondi.',
    't_error_user_internal_login_issue': 'SIERA sta riscontrando problemi di servizio. Ti preghiamo di riprovare più tardi.',
    't_esg_action_plan': 'Piano d\'azione ESG',
    't_esg_dashboard': 'Pannello di controllo ESG',
    't_esg_data_quality': 'Qualità dei dati ESG',
    't_esg_passport': 'Passaporto ESG',
    't_esg_performance': 'Prestazioni ESG',
    't_portfolio_pdf': 'SIERA Portfolio.pdf',
    't_date_range': 'IT Date range',
    't_add_cost_estimate': 'IT Add cost estimate',
    't_add_manager': 'IT Add manager',
    't_est': 'STIM (stimati)',
    't_estimated_overspend': 'stima della spesa eccessiva',
    't_event': 'Evento',
    't_events': 'Eventi',
    't_excel': 'Excel',
    't_expand_full_list': 'Espandi elenco',
    't_expiry': 'scadenza',
    't_export': 'Esportare',
    't_exterior': 'Esterno',
    't_feb': 'Feb',
    't_february': 'Febbraio',
    't_find_asset': 'Cerca beni',
    't_floor_area': 'Superficie',
    't_forgot_password': 'Password dimenticata',
    't_french': 'Francese',
    't_friday': 'Venerdì',
    't_fund': 'Fondo',
    't_fund_reports': 'IT Reports',
    't_fund_report_content': 'IT Report Content',
    't_gas': 'Benzina',
    't_gasFuelsAndThermals': 'Gas, Combustibili E Termiche',
    't_gas_fuel_thermal': 'Benzina, Carburanti ed Energia termica',
    't_gasfuelsandthermals': 'Benzina, Carburanti ed Energia termica ',
    't_german': 'Tedesco',
    't_go': 'Vai',
    't_go_back': 'Torna indietro',
    't_governance_recommendations': 'Raccomandazioni sulla governance',
    't_graph_landlord': 'Locatore',
    't_tenant': 'Locatario',
    't_graph_ytd': 'Da inizio anno',
    't_gresb_measure': 'Azioni correlate a GRESB',
    't_health_and_wellbeing': 'Salute & Benessere',
    't_heatmap_header': 'Metrature individuali',
    't_heatmap_no_meterdata_msg': 'Nessun dato del contatore trovato per l\'utenza e l\'area selezionate.',
    't_heatmap_tooltip_content_txt': '{0} dati mancanti per {1} {2}',
    't_heatmap_tooltip_content_txt_partial': '{0} dati mancanti per',
    't_heatmap_tooltip_content_txt_none': '{0} Tutti i dati raccolti per {1} {2}',
    't_high_efficiency_fixtures': 'Infissi ad alta efficienza / a secco',
    't_impact': 'Impatto',
    't_in_progress': 'In corso',
    't_incorrect_current_password': 'Password attuale non corretta',
    't_installation_equipment': 'Installazione di apparecchiature ed elettrodomestici ad alta efficienza',
    't_instructions': 'IT Instructions',
    't_consumption_loader': 'IT Consumption loader',
    't_bulk_add_template': 'IT Bulk Add Template',
    't_bulk_edit_template': 'IT Bulk Edit Template',
    't_installation_renewable': 'Applicazione di energia rinnovabile in loco',
    't_invalid_token': 'Token non-valido',
    't_italian': 'Italiano',
    't_jan': 'Gen',
    't_january': 'Gennaio',
    't_jpg': 'Grafici JPG',
    't_jul': 'Lug',
    't_july': 'Luglio',
    't_jun': 'Giu',
    't_june': 'Giugno',
    't_kg': 'kg',
    't_kWh': 'kWh',
    't_land_fill': 'Discarica',
    't_landfill': 'Discarica',
    't_landfill_remaining': 'Discarica rimanente',
    't_landlord': 'Locatore',
    't_landlord_complete': 'Proprietario completata',
    't_landlord_missing': 'Proprietario mancante',
    't_language': 'Lingua',
    't_last_quarter': 'Ultimo trimestre',
    't_last_refurb': 'Ultima ristrutturazione',
    't_last_refurbished': 'Ultimo rinnovo',
    't_latest': 'Ultima',
    't_leak_detection_system': 'Sistema di rilevamento perdite',
    't_location': 'Luogo',
    't_logout': 'Disconnetti',
    't_landlord_procured': 'Di competenza del proprietario',
    't_m': 'M',
    't_manager': 'Manager',
    't_management_sys_upgrade': 'Aggiornamenti/sostituzioni dei sistemi di gestione',
    't_selected_asset_stranding': 'IT Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'IT This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_mar': 'Mar',
    't_march': 'Marzo',
    't_may': 'Maggio',
    't_missing': 'INCOMPLETA',
    't_missing_tc': 'Assenti',
    't_missing_lc': 'assenti',
    't_missing_performance_data': 'Dati sulle prestazioni mancanti',
    't_missing_data': 'Dati mancanti',
    't_missing_data_meter': 'Metratura',
    't_missing_data_reading': 'Lettura',
    't_missing_data_type': 'Tipologia',
    't_missing_partial_data': 'Dati parziali mancanti',
    't_meter_water_subsys': 'Misurazione dei sottosistemi idrici',
    't_monday': 'Lunedì',
    't_msg_empty_msg': 'Nessun dato mancante per questo periodo',
    't_msg_no_data': 'Nessun dato',
    't_msg_qtr_empty': 'Nessun dato mancante per il periodo selezionato',
    't_title_meter_view': 'Vista metro',
    't_nc': 'NP (non presenti)',
    't_not_covered_uc': 'IT NOT COVERED',
    't_new_password': 'Nuova password',
    't_no': 'No',
    't_no_action_plan': 'Nessun dato trovato.',
    't_no_completed_action': 'Nessun dato trovato per le Azioni Completate.',
    't_no_data_msg_1': 'Nessun risultato trovato con {0} - Provare con un termine di ricerca diverso.',
    't_no_data_msg_2': 'Nessun risultato trovato.',
    't_no_events_found': 'Nessun evento trovato.',
    't_non_recycled': 'Non rigenerato',
    't_none': 'Nessuno',
    't_non_rec': 'NON RIG',
    't_non_applicable': 'Non applicabile',
    't_not_available': 'N.D.',
    't_notes': 'Note',
    't_notif_template_action': 'L\'azione {0} è a 1 mese dalla data di scadenza. {1}',
    't_notif_template_action_link_1': 'Aggiungi un aggiornamento',
    't_notif_template_data_quality': 'Dati {0} mancanti per contatore: {1}. {2} or {3} da un collega.',
    't_notif_template_data_quality_link_1': 'Richiedi i dati',
    't_notif_template_performance': 'Il rendimento di {0} per {1} è {2}% {3} dell\'obiettivo. {4} per spiegare la varianza.',
    't_notif_template_performance_link_1': 'Aggiungi nota',
    't_notifications': 'Notifiche',
    't_nov': 'Nov',
    't_november': 'Novembre',
    't_occupancy': 'Occupazione',
    't_occupier_eng_tech': 'Coinvolgimento dell\'occupante / tecnologie informatiche',
    't_oct': 'Ott',
    't_october': 'Ottobre',
    't_oil': 'Petrolio',
    't_one_year': '1 anno',
    't_ongoing_waste_monitoring': 'Monitoraggio continuo delle prestazioni dei rifiuti',
    't_onsite_waste_water_treatment': 'Trattamento in loco delle acque reflue',
    't_other': 'Altro',
    't_other_notifications': 'Ti avviseremo anche quando: ',
    't_outdoorexteriorareaparking': 'Parcheggio all\'aperto',
    't_over': 'sopra',
    't_est_overspend': 'eccesso di spesa stim.',
    't_overspend': 'Overspend',
    't_passport': 'Passaporto',
    't_passport_pdf': 'SIERA ESG Passaporto.pdf',
    't_password': 'Password',
    't_password_criteria': 'La password non soddisfa i requisiti',
    't_password_expiry_info': 'La password è scaduta. Crea una nuova password.',
    't_password_mismatch': 'La password non corrispondono, ricontrollare',
    't_password_must_be_different': 'La nuova password non può essere uguale alla password scaduta',
    't_password_rules': 'Deve contenere almeno 10 caratteri e includere una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale.',
    't_password_reset_success': 'La password è stata reimpostata',
    't_past_12_months': 'Ultimi 12 mesi',
    't_pdf': 'PDF a pagina intera',
    't_pdf_exported': 'PDF esportato',
    't_pdf_page': 'Pagina',
    't_pdf_pagination_copyright': '© Il design e il layout di questo rapporto sono copyright di EVORA Global Limited. I dati contenuti in questo rapporto si basano esclusivamente su dati forniti dal cliente e appartenenti al cliente. EVORA Global Limited non è responsabile per la qualità o l\'accuratezza di questi dati.',
    't_perf_pdf': 'SIERA ESG Performance.pdf',
    't_performance': 'Performance',
    't_performance_commerial_event_template': '{0} inquilino {1}',
    't_performance_completed_action_template': '{0} - completata',
    't_performance_data_missing_event_template': 'Dati {0} mancanti per contatore {1}',
    't_performance_event_template': 'Il consumo di {0} per {1} è {2}% {3} dell\'obiettivo',
    't_performance_event_waste_template': 'Il rendimento di {0} per {1} è {2}% {3} dell\'obiettivo',
    't_performance_variance': 'Performance',
    't_data_quality_issue': 'Qualità dei dati',
    't_pop_up_data_missing': 'Dati mancanti',
    't_portfolio_name': 'Portfolio',
    't_posted': 'Postato',
    't_privacy': 'Privacy',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: The Hop Exchange, Suite 73-74, 24 Southwark Street, London, SE1 1TY. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https://ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_provider': 'Fornitore',
    't_quarterly_email_notification': 'Ricevi email trimestrali che evidenzino: ',
    't_recycled': 'Riciclato',
    't_recycling': 'Riciclaggio',
    't_reduction': 'Riduzione',
    't_req_from': 'Da',
    't_req_hi': 'Salve',
    't_red': 'Dati mancanti',
    't_req_meter': 'Metratura',
    't_req_missing_data_period': 'Periodo/i di dati mancanti',
    't_req_recipient': 'Destinatari',
    't_req_send': 'Invia',
    't_req_subject': 'Oggetto',
    't_req_thanks': 'Grazie',
    't_req_utility': 'Utenza',
    't_request_data': 'Richiedi dati',
    't_reset': 'Reimposta',
    't_reuse_storm_water': 'Riutilizzo dell\'acqua piovana e/o delle acque grigie',
    't_req_supplier': 'IT Supplier (if known)',
    't_revenue_service': 'Entrate - Costo del servizio',
    't_saturday': 'Sabato',
    't_save': 'Salva',
    't_saving': 'stima superamento spese',
    't_scope': 'Ambito',
    't_select': 'Seleziona',
    't_send_reminder': 'Invia un promemoria',
    't_sep': 'Set',
    't_september': 'Settembre',
    't_set_dates': 'Imposta date',
    't_set_reminder_date': 'Imposta promemoria',
    't_settings': 'Impostazioni',
    't_sharedservices': 'Servizi condivisi',
    't_show_more': 'Mostra altri',
    't_sign_in': 'Accedi',
    't_six_months': '6 mesi',
    't_smart_grid_tech': 'Smart grid / tecnologie per edifici intelligenti',
    't_social_value': 'Valore sociale',
    't_sort_by': 'Ordina per',
    't_spanish': 'Spagnolo',
    't_status': 'Stato',
    't_submit': 'Invia',
    't_sunday': 'Domenica',
    't_swedish': 'Svedese',
    't_sys_commissioning': 'Messa in servizio o retro-messa in servizio dei sistemi',
    't_title_summary': 'Panoramica',
    't_target': 'Obiettivo',
    't_task': 'Attività',
    't_template_qtr_label': '{0} {1} - {2} {3}',
    't_tenant_complete': 'Inquilino completata',
    't_tenant_missing': 'Inquilino mancante',
    't_tenant_engagement': 'Coinvolgimento dell\'inquilino',
    't_tenant_services': 'Servizi per gli inquilini',
    't_tenantspace': 'Spazio affittato',
    't_terms': 'Condizioni',
    't_this_quarter': 'Questo trimestre',
    't_three_months': '3 mesi',
    't_thursday': 'Giovedì',
    't_title_cannot_request_data': 'Impossibile richiedere i dati',
    't_title_cannot_post_data': 'IT Add user failed',
    't_title_cannot_put_data': 'IT Update user failed',
    't_title_cannot_put_data_group': 'IT Update group failed',
    't_title_cannot_post_data_group': 'IT Add group failed',
    't_title_cannot_add_asset': 'IT Add asset failed',
    't_today': 'Oggi',
    't_ton': 't',
    't_tonnes': 'tonnellate',
    't_total': 'Totale',
    't_total_recycling': 'Riciclaggio totale',
    't_try_again': 'Riprova',
    't_tuesday': 'Martedì',
    't_type': 'Tipologia',
    't_tenant_procured': 'Di competenza del locatario',
    't_under': 'sotto',
    't_under_review': 'In revisione',
    't_under_target': 'sotto target per il periodo',
    't_util_cooling': 'Teleraffreddamento',
    't_util_heating': 'Teleriscaldamento',
    't_utility_type': 'Tipo di utenza',
    't_view_all': 'Vedi tutti',
    't_wall_roof_inst': 'Isolamento parete / tetto',
    't_waste_title': 'Sciupare {0} Raccolta differenziata',
    't_waste_recycling': 'Sciupare Raccolta differenziata',
    't_waste': 'Sprechi',
    't_waste_management': 'Gestione dei rifiuti',
    't_waste_stream_audit': 'Audit del flusso di rifiuti',
    't_water': 'Acqua',
    't_wednesday': 'Mercoledì',
    't_wellbeing': 'Benessere',
    't_wholebuilding': 'Intero edificio',
    't_window_replacement': 'Sostituzioni finestre',
    't_yes': 'Sì',
    't_yesterday': 'Ieri',
    't_y_o_y': 'Base annua',
    't_y_o_y_dialog_text': '<p><strong>La varianza dell\'obiettivo</strong> si riferisce alla performance di un asset da quest\'anno a oggi, rispetto allo stesso periodo dell\'anno scorso per una determinata utilità, visualizzata come variazione percentuale su base annua. Se è stato impostato un obiettivo su un asset in SIERA per i servizi di pubblica utilità, questa percentuale si basa su tale obiettivo. Se non viene fissato alcun obiettivo, la percentuale si basa sull\'anno precedente.</p>',
    't_y_o_y_target': 'Da inizio anno, differenza dal target',
    't_ytd': 'Da inizio anno, differenza dal target',
    't_ytd_uppercase': 'Da inizio anno',
    't_yellow': 'Dati stimati',
    't_show_targets': 'mostra obiettivi',
    't_estimated': 'stimato',
    't_estimate': 'IT ESTIMATED',
    't_start_date': 'data d\'inizio',
    't_end_date': 'data di fine',
    't_month': 'mese',
    't_year': 'anno',
    't_reporting_year': 'IT Reporting Year',
    't_horizontal_artificial': 'IT Horizontal artificial',
    't_vertical_artificial': 'IT Vertical artificial',
    't_asset_values': 'IT Asset Values',
    't_fossil_fuel_exposure': 'IT Fossil Fuel Exposure',
    't_planning_permission_date': 'IT Planning Permission Date',
    't_epc_coverage': 'IT EPC Coverage',
    't_ped': 'IT PED',
    't_nzeb_threshold': 'IT NZEB Threshold',
    't_asset_floor_area': 'IT Asset Floor Area',
    't_total_raw_materials_weight': 'IT Total Raw Materials Weight',
    't_sustainable_raw_materials_weight': 'IT Sustainable Raw Materials Weight',
    't_total_horizontal_area': 'IT Total Horizontal Area',
    't_total_vertical_area': 'IT Total Vertical Area',
    't_artificial_horizontal_area': 'IT Artificial Horizontal Area',
    't_artificial_vertical_area': 'IT Artificial Vertical Area',
    't_missing_field_description': 'IT Missing Field Descriptions',
    't_asset_values_extended': ' ',
    't_sustainable_tonnes': 'IT Sustainable tonnes',
    't_total_tonnes': 'IT Total tonnes',
    't_exposure_select': 'IT Select Exposure',
    't_fossil_fuel_exposure_extended': 'IT An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_planning_permission_date_extended': 'IT  ',
    't_epc_coverage_extended': 'IT  ',
    't_nzeb_threshold_extended': 'IT A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'IT The gross internal area of the asset.',
    't_waste_management_extended': 'IT An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'IT The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'IT Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'IT This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'IT This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': 'IT “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': 'IT “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_source': 'Fonte',
    't_reading': 'Lettura',
    't_picker_filter_value': '{0} mesi alla fine del {1} {2}',
    't_picker_filter_value_single_month': '{0} mese a fine {1} {2}',
    't_variance_from_target': 'Scostamento dal target/anno precedente',
    't_rank': 'classifica',
    't_target_missed': 'Obiettivo mancato',
    't_lower_than_previous': 'Inferiore rispetto all\'anno precedente!',
    't_higher_than_previous': 'Superiore all\'anno precedente',
    't_target_beaten': 'Obiettivo superato!',
    't_variance': 'Varianza',
    't_previous': 'Precedente',
    't_percentage_missing': '% di dati mancanti',
    't_savings': 'Risparmi',
    't_annual_current_consumption': 'Consumo di corrente annuo',
    't_annual_expected_consumption': 'Consumo annuo previsto',
    't_under_recycling_target': 'Under recycling target for period',
    't_over_recycling_target': 'Over recycling target for period',
    't_est_savings': 'IT est. savings',
    't_add_note_dots': 'Aggiungi nota...',
    't_agreed_action': 'Azione concordata',
    't_applicable_action': 'Azione applicabile',
    't_action_under_review': 'Azione in fase di revisione',
    't_notes_lowercase': 'note',
    't_add_variance_note': 'Aggiungi una nota per spiegare la varianza',
    't_delete_warning': 'Sei sicuro di voler eliminare questa azione?',
    't_details': 'Dettagli',
    't_clear': 'Pulisci',
    't_groups': 'IT Groups',
    't_my_groups': 'IT My Groups',
    't_edit_user': 'IT Edit user',
    't_add_photo': 'IT Add photo',
    't_name': 'IT Name',
    't_company': 'IT Company',
    't_role': 'IT Role',
    't_email_address': 'IT Email address',
    't_required_fields': 'IT Required fields ',
    't_save_exit': 'IT Save and exit',
    't_post': 'Pubblica',
    't_edited': 'modificato',
    't_close': 'Chiudi',
    't_calendar': 'Calendario',
    't_chart': 'Grafico',
    't_exclamation': 'Esclamazione',
    't_hand_right': 'In evidenza',
    't_info': 'Info',
    't_no_notes': 'Nessuna nota da visualizzare',
    't_no_redirect_data': 'Nessun reindirizzamento dei dati dal server',
    't_old_password': 'Vecchia password',
    't_confirm_password': 'Conferma password',
    't_property': 'Proprietà',
    't_refresh': 'Aggiorna',
    't_show_hide_pass': 'Mostra/Nascondi password',
    't_tick': 'Seleziona',
    't_help': 'Hai bisogno di aiuto',
    't_help_assistance': 'Se hai bisogno di aiuto, fai clic qui per ricevere assistenza.',
    't_meters': 'Metri',
    't_action_happen': 'Quando l\'azione accadrà',
    't_action_completed': 'Quando l\'azione è completata',
    't_date_format_check': 'Questo formato di data non è riconosciuto, controllare',
    't_show_me': 'Mostra',
    't_months': 'mesi',
    't_end_of': 'alla fine di',
    't_note_post_warning': 'Premi \'Pubblica\' per aggiungere una nota prima di chiudere',
    't_review_date': 'Data di revisione',
    't_warning': 'IT Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_string': '-',
    't_dq_landlord_pdf': 'IT SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'IT SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'IT SIERA Data Quality Meter.pdf',
    't_performance_excel': 'IT SIERA Performance.xlsx',
    't_data_quality_zip': 'IT SIERA Data Quality.zip',
    't_data_quality_excel': 'IT SIERA Data Quality .xlsx',
    't_area': 'IT Area',
    't_events_pfg_msg': 'IT Peformance may have been affected by these events',
    't_last_edit': 'IT Last edit',
    't_reports_create': 'IT Create Report',
    't_completed_data_requirements':'IT Completed Data Requirements',
    't_reports_no_assets': 'IT No assets owned in the reporting year',
    't_reports_SFDR': 'IT {count} SFDR fields',
    't_estimated_data_legend': 'IT Estimated data',
    't_add_details': 'IT Add details',
    't_incomplete_data_legend': 'IT Incomplete data',
    't_not_covered_data_legend': 'IT Not covered',
    't_reports_missing_required': 'IT Missing Required Fields',
    't_reports_missing_optional': 'IT Missing Optional Fields',
    't_reports_data_completeness': 'IT Data Completeness',
    't_reports_report_created_on': 'IT Report created on',
    't_reports_data_completeness_missing': 'IT Consumption Data Missing',
    't_reports_report_completeness': 'IT Report Completeness',
    't_reports_report_completeness_missing': 'IT {count} Assets are missing required data.',
    't_reports_percentage_complete': 'IT {percentage}% complete',
    't_reports_percentage_complete_consumption_data': 'IT {percentage}% complete consumption data',
    't_reports_create_report_header': '{year} IT Report',
    't_reports_save': 'IT Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'IT Planning Permission Date',
    't_reports_assetnzeb_not_found': 'IT NZEB Threshold',
    't_reports_assetped_not_found': 'IT Primary Energy Demand',
    't_reports_giaM2_not_found': 'IT GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'IT GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'IT Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'IT Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'IT Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'IT Total Vertical Area',
    't_reports_gav_not_found': 'IT GAV',
    't_reports_fossilfuelexposure_not_found': 'IT Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'IT Waste Data',
    't_reports_constructionmaterialweight_not_found': 'IT Resource Consumption Data',
    't_reports_assetepc_not_found': 'IT EPC not found',
    't_reports_assetepc_not_valid': 'IT EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'IT EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'IT No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'IT The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'IT The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'IT Explanation',
    't_explanation_placeholder': 'IT Type in explanation',
    't_actions_taken': 'IT Actions Taken',
    't_actions_taken_placeholder': 'IT Type in actions taken',
    't_adverse_impact': 'IT Adverse Impact',
    't_fossil_fuels_exposure': 'IT Fossil Fuels Exposure',
    't_energy_efficiency': 'IT Energy Efficiency',
    't_energy_consumption': 'IT Energy Consumption',
    't_resource_consumption': 'IT Resource Consumption',
    't_adverse_impact_fossil_fuels': 'IT Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency': 'IT Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions': 'IT Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption': 'IT Energy Consumption Intensity',
    't_adverse_impact_waste': 'IT Waste production in operations',
    't_adverse_impact_resource_consumption': 'IT Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity': 'IT Land artificialisation',
    't_impact_value': 'IT Impact Value',
    't_impact_value_fossil_fuels': 'IT Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'IT Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'IT Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'IT Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'IT Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'IT Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'IT Share of non-vegetatedsurface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_lease': 'IT Lease',
    't_back_t_a_users': 'IT Back to all users',
    't_members': 'IT Members',
    't_groups_none': 'IT No Groups Found',
    't_assets_none': 'IT No Assets Found',
    't_selected': 'IT selected',
    't_access': ' to access',
    't_upload': 'IT Upload',
    't_add_asset': 'IT Add asset',
    't_upload_select_or_drop_file': 'IT Select or drop a file',
    't_upload_here_jpg': 'IT here (JPG)',
    't_upload_image': 'IT Upload image',
    't_upload_footer_info': 'IT Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for': 'IT Choose resources for',
    't_admin': 'IT Admin',
    't_administrator': 'IT Administrator',
    't_user1': 'IT User1',
    't_user': 'IT User',
    't_users': 'IT Users',
    't_add_user': 'IT Add user',
    't_recycling_target_beaten': 'IT Recycling target beaten',
    't_more_recycled_than_previous_year': 'IT More recycled than previous year!',
    't_recycling_target_missed': 'IT Recycling target missed',
    't_less_recycled_than_previous_year': 'IT Less recycled than previous year',
    't_next_choose_groups': 'IT Next - Choose Groups',
    't_next_choose_assets': 'IT Next - Choose Assets',
    't_choose_groups_for_new_user': 'IT Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'IT Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'IT Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'IT Choose users who will be able to access  ‘{0}’',
    't_find_group': 'IT Find group',
    't_add_new_group': 'IT Add new group',
    't_created': 'IT Created',
    't_choose_assets_for_update_user': 'IT Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'IT Choose the assets this user will have access to',
    't_last_login': 'IT Last login',
    't_add_new_user': 'IT Add new user',
    't_find_user': 'IT Find user',
    't_home': 'IT Home',
    't_users_not_found': 'IT Sorry we couldn\'t find any Users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'IT Problem getting access',
    't_full_name': 'IT Full name',
    't_create_siera_account': 'IT Create your SIERA account',
    't_password_not_match': 'IT Passwords do not match',
    't_title_cannot_signup': 'IT Signup failed',
    't_title_cannot_post_user_asset_access': 'Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'Update user asset access failed',
    't_retail': 'IT Retail',
    't_office': 'IT Office',
    't_industrial': 'IT Industrial',
    't_residential': 'IT Residential',
    't_hotel': 'IT Hotel',
    't_lodgingleisurerecreation': 'IT Lodging Leisure Recreation',
    't_education': 'IT Education',
    't_technologyscience': 'IT Technology Science',
    't_healthcare': 'IT Healthcare',
    't_mixeduseoffice': 'IT Mixed Use Office',
    't_asset_details': 'IT Asset details',
    't_select_sector': 'IT Select sector',
    't_select_gresb_sector': 'IT Select GRESB sector',
    't_building_utilities': 'IT Building utilities present',
    't_select_building_utilities': 'IT Select building utilities present',
    't_gav_evaluation_date': 'IT GAV evaluation date',
    't_operation_control': 'IT Operational control',
    't_select_operational_control': 'IT Select operational control',
    't_building_details': 'IT Building details',
    't_postcode': 'IT Postcode',
    't_city': 'IT City',
    't_select_city': 'IT Select a city',
    't_select_country': 'IT Select a country',
    't_select_region': 'IT Select a region',
    't_select_date': 'IT Select date',
    't_select_fund': 'IT Select a fund',
    't_asset_ownership': 'IT Fund ownership',
    't_sold_date': 'IT Sold date',
    't_year_built': 'IT Year built',
    't_select_asset_status': 'IT Select asset\'s current status',
    't_current_status': 'IT Current status',
    't_lifecycles_explanation': 'IT Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'IT Lifecycle',
    't_current_status_tooltip': 'IT What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'IT A unique name you assign to assets for easy identification within Siera.',
    't_land': 'IT Land',
    't_standing_investment': 'IT Standing Investment',
    't_new_construction': 'IT New Construction',
    't_major_renovation': 'IT Major Renovation',
    't_static_reporting_data': 'IT Static reporting data',
    't_periodic_reporting_details': 'IT Periodic reporting details',
    't_key_dates': 'IT Key dates',
    't_epc': 'IT EPC',
    't_users_groups': 'IT Users & Groups',
    't_asset_name_tc': 'IT Asset Name',
    't_asset_reference_tc': 'IT Asset Reference',
    't_asset_name': 'IT Asset name',
    't_asset_reference': 'IT Asset reference',
    't_find_address': 'IT Find address',
    't_add_address_manually': 'IT Add address manually',
    't_number_identifier': 'IT Number / Identifier',
    't_street': 'IT Street',
    't_town_city': 'IT Town/City',
    't_county': 'IT County',
    't_country': 'IT Country',
    't_region': 'IT Region',
    't_postcode_zip': 'IT Postcode/ZIP',
    't_sector_type': 'IT Sector type',
    't_gross_asset_value': 'IT Gross Asset Value (GAV)',
    't_fri': 'IT Full repairing and insuring lease',
    't_floor_areas': 'IT Floor Areas',
    't_gia': 'IT Gross Internal Area (GIA)',
    't_nla': 'IT Net Lettable Area (NLA)',
    't_cpa': 'IT Common Parts Area (CPA)',
    't_ext': 'IT External Area (EXT)',
    't_units': 'IT Units',
    't_units_desc': 'IT Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'IT Next - Add Key dates',
    't_form_error_message': 'IT Please fill all the required fields',
    't_asset_existing_group': 'IT This asset is part of a selected fund or group',
    't_organisation': 'IT Organisation',
    't_user_warning_message': 'IT Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': 'IT {0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'IT Confirmation',
    't_user_revocation_successful': 'IT {0} has been successfully revoked',
    't_resend_invite': 'IT Resend invite',
    't_instance': 'IT Instance',
    't_instance_different': 'IT Please select an instance which is not your current one.',
    't_change_instance': 'IT Change instance',
    't_change_instance_explanation': 'IT When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'IT Switch instance?',
    't_wrong_instance_explanation': 'IT You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'IT Re-login to',
    't_switch_to': 'IT Yes, switch to',
    't_could_not_find_groups': 'IT Sorry we couldn\'t find any Groups.',
    't_developer': 'IT Developer',
    't_delete_group': 'IT Delete Group',
    't_description': 'IT Description',
    't_groups_not_found': 'IT Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'IT View all {0} resources',
    't_view_all_assets': 'IT View all {0} assets',
    't_fund_name': 'IT Fund name',
    't_investment_stage': 'IT Investment stage',
    't_search_scheme_asset_name': 'IT Search by scheme and asset name',
    't_green_building_certificates': 'IT Green Building Certificates',
    't_energy_rating_certification': 'IT Energy Rating Certification', 
    't_scheme': 'IT Scheme',
    't_reference_no': 'IT Reference no',
    't_rating': 'IT Rating',
    't_score': 'IT Score',
    't_unit': 'IT Unit',
    't_certified_floor_area': 'IT Certified floor area',
    't_valid_from_date': 'IT Valid from date',
    't_file_upload': 'IT File upload',
    't_uploaded_date': 'IT Upload date',
    't_gav': 'IT GAV',
    't_total_floor_area': 'IT Total floor area',
    't_contains': 'IT Contains',
    't_total_floor_area_gia': 'IT Total floor area (GIA)',
    't_financial_year_starts': 'IT Financial year starts',
    't_carbon_emissions': 'IT Carbon Emissions',
    't_energy_intensity': 'IT Energy intensity',
    't_recycled_waste': 'IT Recycled Waste',
    't_gap_filled_data': 'IT gap-filled data',
    't_below_target': 'IT below target',
    't_above_target': 'IT above target',
    't_key_facts': 'IT Key facts',
    't_funds': 'IT Funds',
    't_my_organisations': 'IT My Organisations',
    't_net_zero_carbon': 'IT Net Zero Carbon',
    't_cco_fund_model': 'IT CCO Fund - Model',
    't_data-source_nzc': 'IT Data source: SIERA ',
    't_kg_co2_year': 'IT kgCO₂e/m²/year',
    't_kwh_m2_year': 'IT kWh/m²/year',
    't_bau_ghg_intensity': 'IT Business as usual (BAU)',
    't_scientific_ghg_intensity': 'IT Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'IT Science based target (2.0C)',
    't_no_organisations_message': 'IT No Organisations Found',
    't_rise': 'IT rise',
    't_fall': 'IT fall',
    't_next_choose_funds': 'IT Next - Choose Funds',
    't_find_fund': 'IT Find fund',
    't_choose_funds_for_user': 'IT Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'IT Choose the funds {0} has access to',
    't_proportion_missing_data': 'IT Portion of missing fund data',
    't_incomplete': 'IT Incomplete',
    't_total_missing': 'IT Total missing',
    't_revoke_access': 'IT Revoke access',
    't_grant_access': 'IT Grant access',
    't_user_access_revoked': 'IT This user\'s access has been revoked',
    't_user_revoke_confirm_message': 'IT This user will be deactivated and will no longer be able to log in.',
    't_actions_by_assets': 'IT Actions by asset ({0})',
    't_overdue': 'IT Overdue',
    't_items_per_page': 'IT Items per page',
    't_of': 'IT of',
    't_total_costs': 'IT Total costs',
    't_non_recoverable': 'IT Non-recoverable',
    't_un_costed': 'IT Un-costed',
    't_gap_filled_data_above_target': 'IT Gap-filled data (above target)',
    't_actual_data_above_target': 'IT Actual data (above target)',
    't_actual_data_legend': 'IT Actual data',
    't_gap_filled_data_legend': 'IT Gap-filled data',
    't_over_target_legend': 'IT Over target',
    't_show': 'IT Show',
    't_quarterly_data': 'IT Quarterly data',
    't_monthly_data': 'IT Monthly data',
    't_how_we_calculate': 'IT How we calculate this',
    't_fund_graph_carbon_explanation': 'IT Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin': 'IT Site admin',
    't_my_account': 'IT My account',
    't_my_profile': 'IT My profile',
    't_aggregated_performance_assets_model': 'Prestazioni aggregate per gli asset utilizzati nel modello',
    't_agreed_overlay_text': 'IT In the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'IT In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'IT Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Qualità dei dati aggregati per le risorse utilizzate nel modello',
    't_based_on_baseline_year': 'Basato sull\'anno di riferimento',
    't_based_on_year': 'IT Based on year',
    't_carbon_intensity': 'Intensità di carbonio',
    't_cost_intensity': 'Intensità dei costi',
    't_co2_emissions': 'Emissioni di CO₂e',
    't_feedback-panel-label': 'IT How could we improve this page?',
    't_feedback_form_header': 'IT Your feedback',
    't_feedback_form_info': 'IT Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'IT Yes, I am happy to be contacted to give more feedback',
    't_target_delta': 'IT target/delta',
    't_sector': 'IT Sector',
    't_no_data_available': 'IT There is no data available',
    't_feedback_success': 'IT Successfully Sent the feedback',
    't_add_feedback_failed': 'IT Add user feedback failed',
    't_about_scopes': 'A proposito di ambiti',
    't_about_scopes_info': 'Queste metriche delle emissioni di carbonio illustrano l\'impatto delle attività necessarie per gestire direttamente un edificio, ad esempio riscaldamento, illuminazione, ecc. Includono le emissioni degli inquilini (ambito 3) per i servizi pubblici utilizzati dagli inquilini degli edifici, ma non includono le attività estese richieste per l\'attività dell\'inquilino.',
    't_more_details': 'Più dettagli',
    't_user_last_loggedIn_at': 'IT Last logged in at {0} on {1}',
    't_total_data_missing': 'IT Total data missing',
    't_landlord_data_missing': 'IT Landlord data missing',
    't_tenant_data_missing': 'IT Tenant data missing',
    't_total_waste': 'Rifiuti totali',
    't_water_intensity': 'Intensità dell\'acqua',
    't_assets_wo_agreed_action': 'IT Assets without agreed actions',
    't_assets_wo_completed_action': 'IT Assets without completed actions',
    't_coverage_by_floor_area': 'IT Floor area coverage',
    't_valid_certs_by_floor_area': 'IT Valid certificates by floor area',
    't_expire_within_12_months': 'IT Expire within 12 months',
    't_no_certs': 'IT No certificates found',
    't_top_impact_cat': 'IT Top 5 impact categories',
    't_user_not_logged_in': 'IT User has not logged in yet.',
    't_total_data': 'IT Total data',
    't_landlord_proc_data': 'IT Landlord-procured data',
    't_tenant_proc_data': 'IT Tenant-procured data',
    't_landlord_proc_building': 'IT Landlord procures whole building',
    't_tenant_proc_building': 'IT Tenant procures whole building',
    't_otherfuelsandthermals': 'IT Other Fuels & Thermals',
    't_funds_none': 'IT No Funds Found',
    't_funds_performance_cost_higher': 'IT higher than previous period',
    't_funds_performance_cost_lower': 'IT lower than previous period',
    't_gap_filled_data_NA': 'IT gap-filling not available',
    't_only_for_annual_data': 'IT Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'IT Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'IT Non-recycled waste',
    't_total_carb_emissions': 'IT total carbon emissions',
    't_total_elec_used': 'IT total electricity used',
    't_total_gas_fuels_thermals': 'IT total gas fuels & thermals',
    't_total_water_used': 'IT total water used',
    't_total_recycled_waste': 'IT total recycled waste',
    't_fund_rise_than_previous_period': 'aumentare rispetto al periodo precedente!',
    't_fund_fall_than_previous_period': 'caduta rispetto al periodo precedente!',
    't_estimated_saving': 'risparmio stimato',
    't_recycledwaste': 'Rifiuti riciclati',
    't_nzc_available_siera': 'IT Net Zero Carbon available in SIERA',
    't_epc_analysis': 'IT EPC Analysis',
    't_water_units': 'm³',
    't_assets_in_the_model': 'asset nel modello',
    't_date_of_export': 'IT Date of export',
    't_target_pathway_info': 'IT Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway': 'IT Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway': 'IT This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway': 'IT Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'IT Target Pathway 1',
    't_action_based_carbon_pathway': 'IT Action based pathway',
    't_action_based_energy_intensity_pathway': 'IT Action based energy intensity pathway',
    't_action_based_pathways': 'IT Action-based pathways',
    't_energy_saving_action': 'IT Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count': 'IT {0} Agreed actions (required)',
    't_applicable_actions_count': 'IT {0} Applicable actions (recommended)',
    't_science_based_target': 'IT CRREM Science Based Targets (SBT)',
    't_SBT_option_1': 'IT 1.5C SBT',
    't_SBT_option_2': 'IT 2.0C SBT',
    't_custom_target_pathways': 'IT Custom target pathways',
    't_tp_stranding_year': 'IT CRREM Misalignment year in ',
    't_show_progress_towards_target_for': 'IT Show progress towards target for ',
    't_cumulative': 'IT Cumulative',
    't_apply': 'IT Apply',
    't_targets': 'IT Targets',
    't_targets_and_pathways': 'IT Targets & Pathways',
    't_grid_decarbonisation': 'IT grid decarbonisation',
    't_title_cannot_create_target_pathway': 'IT Create target pathway failed',
    't_improvement': 'IT Improvement',
    't_epc_available_siera': 'IT Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Sciupare',
    't_model': 'Modella',
    't_models': 'Modelle',
    't_create_new_model': 'Crea un nuovo modello',
    't_open_model': 'Apri un modello',
    't_share_model': 'IT Share model',
    't_link': 'IT Link',
    't_copy_link': 'IT Copy link',
    't_link_copied': 'IT Link copied',
    't_share': 'IT Share',
    't_duplicate_model': 'Modello duplicato',
    't_export_config_data': 'Dati di configurazione di esportazione',
    't_import_config_data': 'Importa dati di configurazione',
    't_search': 'Ricerca',
    't_open': 'Aprire',
    't_no_models_are_created_yet': 'Non sono ancora creati modelli',
    't_default_model': 'Imposta come modello predefinito',
    't_delete_model': 'Elimina il modello',
    't_delete_yes_cancel': 'cancella questo! /',
    't_bau_stranding': 'IT BAU CRREM Misalignment',
    't_no_model': 'IT No models found',
    't_create_new_model_para': 'Questo creerà un modello da tutte le attività attuali e valide in questo fondo. A tutti gli asset che non dispongono di dati di consumo sufficienti verrà applicato un benchmark per settore e paese.',
    't_create': 'Creare',
    't_name_required': 'Il nome è obbligatorio.',
    't_model_name_not_valid': 'IT Enter a valid model name',
    't_save_changes': 'Salvare le modifiche',
    't_filter': 'Filtro',
    't_all_sectors': 'IT All sectors',
    't_all_countries': 'IT All countries',
    't_assets_filter_result': 'IT {0} out of {1} assets will be displayed',
    't_assets_filter_count': 'IT filters selected:',
    't_assets_filter_title': 'IT Filter',
    't_about_gap_filled_data': 'IT About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>IT Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'IT Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'IT No results found.',
    't_no_graph_data': 'IT No graph data',
    't_getting_scope_data': 'IT Getting Scope Data...',
    't_creating_default_scope': 'IT Creating default scope...',
    't_rise_over_previous_period': 'IT rise over previous period',
    't_sort': 'Ordinare',
    't_lowest_first': 'Prima il più basso',
    't_highest_first': 'Il più alto prima',
    't_nzc_data_missing': 'IT Data missing',
    't_nzc_carbon_intensity': 'IT Carbon intensity',
    't_current_action_plan': 'IT Current Action Plan',
    't_current_epc_analysis': 'IT Current EPC Analysis',
    't_sold': 'IT SOLD',
    't_data_warning': 'IT DATA WARNING',
    't_siera_experience_feedback': 'IT I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'IT assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'IT These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'IT View these assets',
    't_export_model_explanation_text': 'IT You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'IT You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'IT The export file name must not contain more than 50 characters',
    't_top': 'IT Top',
    't_import_model_explanation_text': 'IT To import asset data from Excel you must use the {0} template',
    't_import': 'IT Import',
    't_drag_file': 'IT Drag file to upload, or',
    't_select_file': 'IT Select a file',
    't_import_create_explanation': 'IT What do you want the new NZC model to be called?',
    't_upload_success_msg': 'IT has been successfully uploaded',
    't_upload_error_msg': 'IT There are problems with your file',
    't_row': 'IT Row',
    't_copy_clipboard': 'IT Copy to clipboard',
    't_select_valid_file': 'IT Select a valid file',
    't_copied': 'IT Copied',
    't_loading': 'IT Loading',
    't_procurement_tabs_explanation_title': 'IT What do these categories mean?',
    't_data_categories': 'IT Data Categories',
    't_about_procurement_data_categories': 'IT <p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'IT This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'IT This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'IT Delete Target Pathway',
    't_delete_target_pathway_message': 'IT Are you sure you want to delete this pathway?',
    't_add_another_target_pathway': 'IT Add another Target Pathway',
    't_add_a_target_pathway': 'IT Add a Target Pathway',
    't_target_pathway': 'IT Target pathway',
    't_milestone_years': 'IT Milestone years',
    't_group_leaving_confirmation': 'IT Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason': 'IT What is your reason for leaving the group?',
    't_request': 'IT Request',
    't_leave_group': 'IT Request to leave the group',
    't_add_group': 'IT Create new Group',
    't_target_warning': 'IT The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'IT Chart options',
    't_plot_data_assets': 'IT Plot data for individual assets',
    't_display_benchmark': 'IT Display benchmark',
    't_data_source': 'IT Data source',
    't_show_progress_relative': 'IT Show progress relative to target for',
    't_base_line_year': 'IT Baseline year',
    't_raw_data': 'IT Raw data',
    't_uplifted_data': 'IT Uplifted data',
    't_siera': 'IT SIERA',
    't_imported': 'IT Imported',
    't_complete_data': 'IT Complete data',
    't_uplifted_estimated_data': 'IT Uplifted/estimated data',
    't_benchmark_data': 'IT Benchmarked data',
    't_choose_assets_group_for_update_user': 'IT Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'IT Choose assets for this group to access',
    't_previous_period': 'IT Previous period',
    't_this_period': 'IT This period',
    't_gap_filled': 'IT Gap filled',
    't_combined': 'IT Combined',
    't_actual_and_supplier_estimated': 'IT Actual & supplier estimated',
    't_recycled_waste_previous': 'IT Recycled waste (previous)',
    't_group_name': 'IT Group name',
    't_email_leave_group': 'IT To request to leave this group, please email',
    't_data_shown': 'IT Data shown',
    't_show_details': 'IT Show details',
    't_hide_details': 'IT Hide details',
    't_view_asset': 'IT View asset',
    't_gia_small_form': 'IT GIA',
    't_asset_ref': 'IT Asset ref',
    't_stranding_year': 'IT CRREM Misalignment year',
    't_energy_saving': 'IT Energy-saving actions',
    't_target_stranding_year': 'IT Target pathway CRREM Misaligned in ',
    't_bau_stranding_year': 'BAU CRREM Misalignment in ',
    't_next_users': 'IT Next - Choose Users',
    't_delete_group_msg': 'IT Are you sure you want to delete this group?',
    't_edit_group': 'IT Edit group : ',
    't_all_assets': 'IT All assets',
    't_not_included_in_model': 'IT Not included in current NZC model',
    't_including_gap_filled': 'IT Including gap-filled data',
    't_excluding_gap_filled': 'IT Excluding gap-filled data',
    't_asset_without_energy_saving_action': 'IT Assets with no energy saving actions specified',
    't_sold_assets': 'IT Sold assets',
    't_sold_label': 'IT Asset sold',
    't_asset_status': 'IT Asset status',
    't_no_data_for_previous_period': 'IT no data for previous period',
    't_x_axis_scale': 'IT X-axis scale',
    't_y_axis_scale': 'IT Y-axis scale',
    't_autoscale': 'IT Autoscale',
    't_from': 'IT From',
    't_to': 'IT to',
    't_min': 'IT Min',
    't_max': 'IT Max',
    't_selected_asset': 'IT Selected asset',
    't_no_gresb_sector_error_message': 'IT Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'IT Asset has critical information missing',
    't_asset_sold_date_message': 'IT Asset sold in',
    't_more_recycled': 'IT more recycled than previous period',
    't_less_recycled': 'IT less recycled than previous period',
    't_required_group_field': 'IT Required field',
    't_form_group_error_message': 'IT Please fill the required field',
    't_upload_nzc_data_failed': 'IT Upload NZC import data failed',
    't_nzc_file_uploaded_success': 'IT {0} file successfully uploaded',
    't_default_model_name': 'IT Default model',
    't_metric': 'IT Metric',
    't_imperial': 'IT Imperial',
    't_energy_intensity_popup_header': 'IT Coming soon',
    't_energy_intensity_popup_body': 'IT Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'IT Coming soon',
    't_epc_analysis_popup_body': 'IT <p>Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'IT Model notes',
    't_setting_default_model_failed': 'IT Setting model as default failed',
    't_set_as_default': 'IT Set as Default Model',
    't_set_as_default_info': 'IT This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'IT This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_nzc_default_text': 'IT NZC default',
    't_unable_to_plot_NZC_chart': 'IT Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'IT No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'IT Please {contactEvora} if you require help.',
    't_contact_Evora': 'IT contact Evora',
    't_Contact_Evora': 'IT Contact Evora',
    't_model_no_data_available': 'IT No data available',
    't_select_target_pathway': 'IT Select Target Pathway',
    't_define_target_pathway': 'IT Define a custom target pathway',
    't_name_must_not_exceed_100_characters': 'IT The model name must not contain more than 100 characters',
    't_no_meter_information': 'IT No meter information.',
    't_no_assets': 'IT 0 assets',
    't_show_stranding_dates': 'IT Show CRREM Misalignment dates',
    't_default': 'IT Default',
    't_current_model': 'IT Current model',
    't_based_on': 'IT Based on',
    't_past_3_months': 'IT Past 3 months',
    't_past_6_months': 'IT Past 6 months',
    't_current_year_till_previous_month': 'IT Current year till previous month',
    't_model_with_same_name_exists': 'IT Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'IT Apply Filter to view these assets',
    't_session_expiry': 'IT Your session is going to expire soon. Would you like to log out?',
    't_session_expiry_warning': 'IT For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'IT Do you want to stay logged in?',
    't_stay_logged_in': 'IT Stay logged in',
    't_log_out_now': 'IT Log out now',
    't_jpeg': 'IT JPEG',
    't_svg': 'IT SVG',
    't_currency': 'IT Currency',
    't_nzc_session_model_deleted': 'IT {0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_estimated_savings': 'IT Estimated Savings',
    't_procured_by': 'IT Procured by',
    't_area_covered': 'IT Area Covered',
    't_shared_services': 'IT Shared services',
    't_scope_index': 'IT Scope {0}',
    't_import_model_explanation_note_link': 'IT To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'IT Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'IT You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'IT Add',
    't_btn_update_and_add': 'IT Update and add',
    't_gresb_measure_water': 'IT Performed a technical building assessment to identify water efficiency improvements',
    't_gresb_measure_waste': 'IT Performed a technical building assessment to identify waste efficiency improvements',
    't_gresb_measure_energy': 'IT Performed a technical building assessment to identify energy efficiency improvements',
    't_nzc_data_availability': 'IT Data availability',
    't_valid_ratings_by_floor_area': 'IT Valid scores by floor area',
    't_certified_assets_by_floor_area': 'IT Certified assets by floor area',
    't_ratings_last_sync_on': 'IT Scores last synced on {0}',
    't_certified': 'IT certified',
    't_energy_star_analysis': 'IT Energy Star Analysis',
    't_energy_star_score': 'IT Energy Star Score',
    't_energy_star_last_synced': 'IT This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_kg_co2_m2_yr': 'IT kgCO₂e/m²/yr',
    't_kg_co2_yr': 'IT kgCO₂e/yr',
    't_kWh_m2_yr': 'IT kWh/m²/yr',
    't_energy_star_set': 'IT Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'IT Hit Post to add your note before closing',
    't_energy_star_integration': 'IT Energy Star Integration',
    't_es_sub_text': 'IT Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'IT Learn more',
    't_es_step_title': 'IT Step {0} of {1}: {2}',
    't_es_step_one': 'IT Log into ES Portfolio Manager and add SIERA as a contact',
    't_es_step_two': 'IT Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'IT Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'IT Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': 'IT {0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'IT Log into your Energy Star Portfolio Manager',
    't_es_prompted_username': 'IT When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button': 'IT I have added Evora_Siera as a contact',
    't_es_requested_account_text': 'IT {0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id': 'IT Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection': 'IT Confirm connection',
    't_es_not_recognise_request': 'IT If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'IT Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'IT Sharing',
    't_es_select_share': 'IT Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'IT Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'IT I have set up sharing',
    't_es_available_assets': 'IT These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'IT If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'IT Contact Support',
    't_es_confirm': 'IT Confirm',
    't_es_asset_in_siera': 'IT Asset in SIERA',
    't_es_asset_in_portfolio_manager': 'IT Respective Asset in ES Portfolio Manager',
    't_es_success': 'IT You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'IT Success',
    't_continue': 'IT Continue',
    't_action_based_pathway_stranding': 'IT Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'IT Fund carbon intensity',
    't_fund_energy_intensity': 'IT Fund energy intensity',
    't_es_step_three_error': 'Error: IT We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error': 'Error: IT We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error': 'Error: IT Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error': 'Error: IT Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'IT Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'IT Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'IT These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': 'IT {0} of {1} Assets matched',
    't_es_sync_frequency': 'IT Sync frequency',
    't_es_match_more_assets': 'IT Match more Assets',
    't_address': 'IT Address',
    't_last_sync': 'IT Last Sync',
    't_jpeg_small': 'IT Small JPEG',
    't_png_small': 'IT Small PNG',
    't_jpeg_medium': 'IT Medium JPEG',
    't_png_medium': 'IT Medium PNG',
    't_jpeg_large': 'IT Large JPEG',
    't_png_large': 'IT Large PNG',
    't_max_length_30': 'IT Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name': 'IT The custom pathway name must be unique',
    't_tp_name_validation': 'IT Name can only contain numbers & letters',
    't_monthly': 'IT Monthly',
    't_yearly': 'IT Yearly',
    't_mean_carbon_intensity': 'IT Mean carbon intensity',
    't_data_availability_assets': 'IT Data availability of assets',
    't_uplifted': 'IT Uplifted',
    't_benchmark': 'IT Benchmarked',
    't_target_pathway_2': 'IT Target Pathway 2',
    't_target_pathway_3': 'IT Target Pathway 3',
    't_unique_custom_target_pathway_name': 'IT Custom pathway name must be unique',
    't_tp_name_empty': 'IT Custom pathway name cannot be empty',
    't_example': 'IT E.g.',
    't_no_assets_to_match': 'IT No assets to match.',
    't_intensity': 'IT Intensity',
    't_portfolio_excel': 'IT SIERA Portfolio.xlsx',
    't_excel_tab_name': 'IT Assets Raw Data',
    't_client_name': 'IT Client',
    't_agent_name': 'IT Agent',
    't_purchase_date': 'IT Purchase date',
    't_sale_date': 'IT Sale date',
    't_property_status': 'IT Property Status',
    't_gresb_sector': 'IT GRESB sector',
    't_energy_star_sector': 'IT Energy Star sector',
    't_select_energy_star_sector': 'IT Select Energy Star sector',
    't_gresb_management_status': 'IT GRESB management status',
    't_gia_m_sqrt': 'IT GIA (m2)',
    't_nla_m_sqrt': 'IT NLA (m2)',
    't_cpa_m_sqrt': 'IT CPA (m2)',
    't_is_cpa_estimated': 'IT Is CPA estimated?',
    't_gas_expected': 'IT Gas expected',
    't_water_expected': 'IT Water expected',
    't_electricity_expected': 'IT Electricity expected',
    't_oil_expected': 'IT Oil expected',
    't_district_heating_expected': 'IT District heating expected',
    't_district_cooling_expected': 'IT District cooling expected',
    't_fund_performance_excel': 'IT SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'IT View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report': 'IT Fund Carbon Performance Report',
    't_fund_electricity_performance_report': 'IT Fund Electricity Performance Report',
    't_fund_thermals_performance_report': 'IT Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report': 'IT Fund Waste Performance Report',
    't_fund_water_performance_report': 'IT Fund Water Performance Report',
    't_fund_level_summary': 'IT Fund Level Summary',
    't_total_consumption_excel': 'IT Total Consumption (MWh)',
    't_asset_level_total_consumption_excel': 'IT Total Consumption ({0})',
    't_total_emission_excel': 'IT Total Emissions ({0})',
    't_total_consumption': 'IT Total Consumption ({0})',
    't_total_carbon_emission_excel': 'IT Total Carbon Emission (T)',
    't_gap_filled_data_excel': 'IT Gap Filled Data (%)',
    't_over_under_target_excel': 'IT Over/Under target (%)',
    't_time_period_excel': 'IT Time Period',
    't_asset_information_excel': 'IT Asset Information',
    't_floor_area_excel': 'IT Floor Area (m2)',
    't_floor_area_excel_imperial': 'IT Floor Area (ft2)',
    't_occupancy_excel': 'IT Occupancy (%)',
    't_intensity_excel': 'IT Intensity ({0})',
    't_carbon_intensity_excel': 'IT Carbon intensity ({0})',
    't_recycled_waste_excel': 'IT Recycled Waste (t)',
    't_total_waste_excel': 'IT Total Waste (t)',
    't_recycled_percentage_excel': 'IT % Recycled',
    't_recycled_percentage_change_excel': 'IT % change in recycled waste',
    't_post_code': 'IT Post code',
    't_interim_target': 'IT Interim target',
    't_month_to_end_of': 'IT month to end of', // to be updated
    't_months_to_end_of': 'IT months to end of', // to be updated
    't_energy_intensity_excel': 'IT Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'IT Update target pathway failed',
    't_title_delete_target_pathway_failed': 'IT Delete target pathway failed',
    't_ton_co2_yr': 'IT tCO₂e/yr',
    't_average_carbon_intensity': 'IT Average Carbon intensity',
    't_average_energy_intensity': 'IT Average Energy intensity',
    't_average_cost_intensity': 'IT Average Cost intensity',
    't_performance_assets_model': 'IT Performance for assets used in model',
    't_energy_intensity_nzc': 'IT Energy intensity',
    't_selected_utility_excel': 'IT {0} - EXCEL',
    't_all_utilities_excel': 'IT All utilities - EXCEL',
    't_gas_fuels_thermals': 'IT Gas, fuels and thermals',
    't_total_energy_consumption': 'IT Total energy consumption (MWH)',
    't_fund_performance_report': 'IT Fund Performance Report',
    't_energy_summary': 'IT Energy Summary',
    't_remove_match': 'IT Remove match',
    't_remove': 'IT Remove',
    't_action_by_impact_excel': 'IT Actions by impact - EXCEL',
    't_action_by_status_excel': 'IT Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'IT Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'IT Are you sure you want to cancel the integration {0} set up process?',
    't_es_reset_warning_header_message': 'IT Cancel integration set up process',
    't_es_reset_warning_yes': 'IT Yes, cancel',
    't_es_reset_warning_no': 'IT Stay on step 4',
    't_tenant_data_quality': 'IT Tenant data quality',
    't_landlord_data_quality': 'IT Landlord data quality',
    't_tenant_procured_assets': 'IT Tenant procured assets',
    't_landlord_procured_assets': 'IT Landlord procured assets',
    't_actual_percentage': 'IT Actual (%)',
    't_supplier_estimated_percentage': 'IT Supplier estimated (%)',
    't_incomplete_percentage': 'IT Incomplete (%)',
    't_not_covered_percentage': 'IT Not covered (%)',
    't_total_missing_percentage': 'IT Total missing (%)',
    't_managing_agent': 'IT Managing agent',
    't_portion_of_missing_fund_data_percentage': 'IT Portion of missing fund data (%)',
    't_dq_floor_area_landlord': 'IT Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant': 'IT Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data': 'IT Floor area for which you have no data ({0})',
    't_dq_floor_area': 'IT Floor area ({0})',
    't_fund_data_quality_excel': 'IT Fund Data Quality Excel',
    't_fund_data_quality_report': 'IT Fund Data Quality Report',
    't_upload_consumption_data': 'IT Upload consumption data',
    't_upload_action_plans': 'IT Upload action plans',
    't_action_plan_point_two': 'IT Upload actions data',
    't_consumption_upload_sub_text': 'IT Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'IT You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'IT Download and populate your consumption template',
    't_action_plan_upload_template_point_one': 'IT Generate and populate your template',
    't_consumption_upload_point_one_subtext': 'IT Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'IT Populate the template with your list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'IT Generate template',
    't_upload_template': 'IT Upload template',
    't_action_plan_upload_point_two_subtext': 'IT When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'IT Data upload successful',
    't_consumption_upload_success_text_one': 'IT Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'IT Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': 'IT {0} action plans have been uploaded. Uploaded on {1} by {2}',
    't_action_upload_success_text_two': 'IT Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'IT Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'IT Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'IT We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'IT Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'IT Return home',
    't_return_action':'IT Return to Actions',
    't_upload_bulk_consumption': 'IT Bulk add consumption',
    't_upload_bulk_action_plan': 'IT Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'IT OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'IT Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'IT You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'IT Action Plan Report',
    't_total_agreed_actions': 'IT Total agreed actions',
    't_un_costed_actions': 'IT Un-costed actions',
    't_unit_of_measurement': 'IT Unit of measurement',
    't_overdue_actions': 'IT Overdue actions',
    't_under_review_actions': 'IT Actions under review',
    't_fund_agreed_actions_summary': 'IT Fund level summary of agreed actions',
    't_fund_overdue_actions_summary': 'IT Fund level summary of overdue actions',
    't_fund_completed_actions_summary': 'IT Fund level summary of completed actions',
    't_fund_applicable_actions_summary': 'IT Fund level summary of applicable actions',
    't_fund_under_review_actions_summary': 'IT Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'IT Fund ActionPlan (by status)',
    't_no_fund_actions_with_status': 'IT This fund has no actions with this status',
    't_actions_per_year': 'IT Actions per year',
    't_asset_performance_excel': 'IT Asset performance EXCEL',
    't_gas_fuels_performance': 'IT Gas, Fuels & Thermals performance report',
    't_water_performance': 'IT Water performance report',
    't_waste_performance': 'IT Waste performance report',
    't_carbon_performance': 'IT Carbon performance report',
    't_asset_performance_export': 'IT Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'IT Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'IT Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'IT Gap-filled energy data (%)',
    't_current_energy_consumption': 'IT Current energy consumption (KWH)',
    't_generate_your_template': 'IT Generate your consumption template',
    't_generate_your_action_plan_template': 'IT Generate your action plan template',
    't_asset_details_excel': 'IT Asset details EXCEL',
    't_no_data_to_export': 'IT No data available to export',
    't_total_carbon_emissions': 'IT Total Carbon Emissions ({0})',
    't_landlord_summary': 'IT Landlord summary',
    't_tenant_summary': 'IT Tenant summary',
    't_dq_floor_area_gia': 'IT Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel': 'IT Fund ActionPlan (by impact)',
    't_total_actions_for_category': 'IT Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary': 'IT Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary': 'IT Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary': 'IT Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary': 'IT Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary': 'IT Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary': 'IT Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary': 'IT Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary': 'IT Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary': 'IT Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary': 'IT Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary': 'IT Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title': 'IT Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title': 'IT Actions with building performance impact',
    't_actions_with_community_engagement_impact_title': 'IT Actions with community engagement impact',
    't_actions_with_energy_impact_title': 'IT Actions with energy impact',
    't_actions_with_governance_recommended_impact_title': 'IT Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title': 'IT Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title': 'IT Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title': 'IT Actions with tenant engagement impact',
    't_actions_with_waste_impact_title': 'IT Actions with waste recycling impact',
    't_actions_with_water_impact_title': 'IT Actions with water impact',
    't_actions_with_other_impact_title': 'IT Actions with other impact',
    't_fund_level_energy_summary': 'IT Fund level energy summary',
    't_asset_information': 'IT Asset information',
    't_total_floor_area_m2': 'IT Total Floor Area (m2)',
    't_tenant_controlled_asset': 'IT Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg': 'IT Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh': 'IT Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg': 'IT Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh': 'IT Previous annual consumption (KWH)',
    't_intensity_unit': 'IT Intensity ({0})',
    't_benchmark_kwh/m2': 'IT Benchmark (kWh/m2)',
    't_benchmark_m3/m2': 'IT Benchmark (m3/m2)',
    't_landfill_unit': 'IT Landfill ({0})',
    't_incinerated': 'IT Incinerated ({0})',
    't_recycled_unit': 'IT Recycled ({0})',
    't_reuse_unit': 'IT Reuse ({0})',
    't_anaerobic_t': 'IT Anaerobic (t)',
    't_hazardous_t': 'IT Hazardous (t)',
    't_unknown_unit': 'IT Unknown ({0})',
    't_total_t': 'IT Total (t)',
    't_energy_performance_report': 'IT Energy Performance Report',
    't_electricity_performance_report': 'IT Electricity Performance Report',
    't_gas_fuels_thermals_report': 'IT Gas, Fuels & Thermals Performance Report',
    't_water_performance_report': 'IT Water Performance Report',
    't_waste_performance_report': 'IT Waste Performance Report',
    't_carbon_performance_report': 'IT Carbon Performance Report',
    't_unsaved_changes': 'IT Unsaved changes',
    't_unsaved_changes_message': 'IT Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'IT Leave without saving',
    't_save_and_leave': 'IT Save and leave',
    't_support_guides': 'IT Support Guides',
    't_release_notes': 'IT Release Notes',
    't_asset_performance_report': 'IT Asset Performance Report',
    't_is_the_asset_tenant': 'IT Is the asset tenant controlled?',
    't_current_consumption': 'IT Current consumption',
    't_current_year_gap': 'IT Current year gap filled Data (%)',
    't_previous_annual_consumption': 'IT Previous annual consumption',
    't_previous_year_gap': 'IT Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'IT Unit of measurement for consumption',
    't_benchmark_name': 'IT Benchmark',
    't_unit_of_measurement_for_intensity': 'IT Unit of measurement for intensity',
    't_kwh_m2': 'IT kWh/m2',
    't_m3': 'IT m3',
    't_m3_m2': 'IT m3/m2',
    't_kg_co2_m2': 'IT kg CO2e/m2',
    't_current_total_waste': 'IT Current Total Waste (t)',
    't_current_recycled_waste': 'IT Current Recycled Waste (t)',
    't_current_recycled': 'IT Current % Recycled',
    't_previous_total_waste': 'IT Previous Total Waste (t)',
    't_previous_recycled_waste': 'IT Previous Recycled Waste (t)',
    't_previous_recycled': 'IT Previous % Recycled',
    't_agreed_and_applicable_actions': 'IT Agreed and applicable actions',
    't_generate_template_user_text': 'IT The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'IT Type of record',
    't_template_to_generate': 'IT Template to generate',
    't_time_period': 'IT Time period',
    't_time_period_user_text': 'IT The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'IT Meters included in template',
    't_file_name': 'IT File name',
    't_include_inactive_meters': 'IT Include inactive meters',
    't_generate': 'IT Generate',
    't_landlord_procured_meters': 'IT Landlord procured meters',
    't_tenant_procured_meters': 'IT Tenant procured meters',
    't_both': 'IT Both',
    't_asset_action_plans_excel': 'IT Asset action plans EXCEL',
    't_asset_data_quality_excel': 'IT Asset data quality EXCEL',
    't_benchmark_line': 'IT Benchmark line',
    't_no_benchmark': 'IT No Benchmark',
    't_benchmark_office_ac': 'IT BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'IT BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'IT consumption upload',
    't_action_upload': 'IT action upload',
    't_bulk_consumption_instruction_header': 'IT SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'IT SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'IT SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note': 'IT Please note:',
    't_bulk_consumption_instruction_one': 'IT The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'IT In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'IT We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'IT Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'IT We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'IT This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'IT If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight': 'IT If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'IT This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'IT This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'IT In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'IT In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'IT Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'IT Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'IT Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'IT Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'IT If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name': 'IT This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility': 'IT The utility type this meter is associated with.',
    't_bulk_consumption_tooltip_area_covered': 'IT The area of the property which this meter covers.',
    't_bulk_consumption_tooltip_is_active': 'IT Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number': 'IT The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name': 'IT The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date': 'IT The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date': 'IT The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin': 'IT The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption': 'IT Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated': 'IT Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'IT Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'IR Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'IR Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'IT Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'IT Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'IT Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'IT Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'IT Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_import_model_explanation_note_asset_name': 'IT You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'IT EvoraNZCData',
    't_summary': 'IT Summary',
    't_asset_performance_excel_file_name': 'IT SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh': 'IT Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh': 'IT Total Energy Consumption (kWh)',
    't_action_export_from_portfolio_view': 'IT Actions export from portfolio view',
    't_summary_of_agreed_action': 'IT Summary of agreed actions',
    't_total_overdue_action': 'IT Total overdue actions',
    't_total_completed_action': 'IT Total completed actions',
    't_total_applicable_action': 'IT Total applicable actions',
    't_total_action_under_review': 'IT Total actions under review',
    't_action_estimated_savings': 'IT Estimated savings',
    't_action_area_covered': 'IT Area covered',
    't_summary_of_overdue_action': 'IT Summary of overdue actions',
    't_summary_of_completed_actions': 'IT Summary of completed actions',
    't_summary_of_applicable_actions': 'IT Summary of applicable actions',
    't_summary_of_actions_under_review': 'IT Summary of actions under review',
    't_no_assets_selected_actions_status': 'IT The assets selected have no actions with this status',
    't_missing_fund_data_weighted_by_floor_area': 'IT Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'IT Floor area not covered ({0})',
    't_floor_area_not_covered_percentage': 'IT Floor area not covered (%)',
    't_portfolio_data_quality_report': 'IT Data Quality Report',
    't_portfolio_data_quality_file_name': 'IT Portfolio Data Quality Report',
    't_current_energy_consumption_kwh': 'IT Current Energy Consumption (kWh)',
    't_level_of_details_by_asset': 'IT By asset',
    't_level_of_details_by_meter': 'IT By meter',
    't_time_period_granularity_annual': 'IT Annual',
    't_time_period_granularity_monthly': 'IT Monthly',
    't_level_of_detail': 'IT Level of detail',
    't_time_period_granularity': 'IT Time period granularity',
    't_name_must_not_exceed_50_characters': 'IT The model name must not contain more than 50 characters',
    't_current_reporting_period_total_energy_consumption': 'IT Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage': 'IT Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption': 'IT Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage': 'IT Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area': 'IT Total Asset Floor Area ({0})',
    't_reporting_period': 'IT Reporting Period',
    't_reporting_period_gap_filler_data_percentage': 'IT Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions': 'IT Reporting Period Carbon Emissions ({0})',
    't_current_reporting_period_total_consumption': 'IT Current Reporting Period Total Consumption ({0})',
    't_current_reporting_period_gap_filled_data_percentage': 'IT Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption': 'IT Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage': 'IT Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste': 'IT Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste': 'IT Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled': 'IT Current % Recycled',
    't_previous_reporting_period_total_waste': 'IT Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste': 'IT Hazardous Waste ({0})',
    't_non_hazardous_waste': 'IT Non-hazardous Waste ({0})',
    't_total_waste_generated': 'IT Total Waste Generated ({0})',
    't_waste_to_energy_unit': 'IT Waste to energy ({0})',
    't_waste_generated': 'IT Waste Generated',
    't_destination': 'IT Destination',
    't_current_reporting_period_total_emissions': 'IT Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions': 'IT Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste': 'IT Previous Reporting Period Recycled Waste ({0})',
    't_emissions': 'IT Emissions',
    't_current_total_carbon_emissions': 'IT Current total Carbon Emissions ({0})',
    't_scope_1_emissions': 'IT Scope 1 emissions ({0})',
    't_scope_2_emissions': 'IT Scope 2 emissions ({0})',
    't_scope_3_emissions': 'IT Scope 3 emissions ({0})',
    't_utility_meter_unavailable': 'IT Unavailable: no meter for',
    't_current_period_consumption_with_gapFilled_data': 'IT Current period consumption ({0})',
    't_current_period_gapFilled_data': 'IT Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data': 'IT Previous period consumption ({0})',
    't_previous_period_gapFilled_data': 'IT Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'IT Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'IT Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'IT Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'IT Previous energy consumption ({0})',
    't_import_file_error_message': 'IT The import file name must not contain more than 50 characters',
    't_no_export_data_available': 'IT The assets selected have no data available for this utility within the specified time frame.',
    't_current_reporting_period_gap_filled_energy_data_percentage': 'IT Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage': 'IT Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name': 'IT Meter name',
    't_serial_number': 'IT Serial number',
    't_comment': 'IT Comment',
    't_active_from': 'IT Active from',
    't_active_to': 'IT Active to',
    't_is_this_a_submeter': 'IT Is this a submeter?',
    't_floor_area_served_by_meter': 'IT Floor area served by Meter ({0})',
    't_green_tariff': 'IT Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'IT Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'IT Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served': 'IT Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'IT Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'IT Waste disposal route reference',
    't_contractor': 'IT Contractor',
    't_waste_type': 'IT Waste Type',
    't_previous_period_carbon_emissions': 'IT Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'IT Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information': 'IT Meter Information',
    't_actions_date': 'Based on {0}',
    't_export_performance_excel': 'IT Export performance - EXCEL',
    't_water_intensity_excel': 'IT Water Intensity ({0})',
    't_export_data_quality_excel': 'IT Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data': 'IT Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data': 'IT Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'IT Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'IT Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'IT Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions': 'IT In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'IT In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'IT Data below target',
    't_gap_filled_data_below_target': 'IT Gap-filled data below target',
    't_data_above_target': 'IT Data above target',
    't_gap_filled_data_above_target_updated': 'IT Gap-filled data above target',
    't_data_below_previous_period': 'IT Data below previous period',
    't_gap_filled_data_below_previous_period': 'IT Gap-filled data below previous period',
    't_data_above_previous_period': 'IT Data above previous period',
    't_gap_filled_data_above_previous_period': 'IT Gap-filled data above previous period',
    't_carbon_scope_info': '<p><b>IT Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'IT Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_industry_standard_benchmark': 'IT Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'IT Variance against Industry Standard Benchmark (%)',
    't_asset_nzc_action_based_target_pathway_info': 'IT Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info': 'IT Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'IT kWh/m²/yr',
    't_assets_with_scores': 'IT Assets with scores',
    't_gav_coverage': 'IT GAV coverage',
    't_date_completed': 'IT Date completed',
    't_total_emissions': 'IT Total Emissions',
    't_scope1_emissions': 'IT Scope 1 Emissions',
    't_scope2_emissions': 'IT Scope 2 Emissions',
    't_scope3_emissions': 'IT Scope 3 Emissions',
    't_missing_fund_data_weighted': 'IT Missing fund data, weighted by floor area (%)',
    't_commercial': 'IT Commercial',
    't_no_data_for_comparison': 'IT No data for comparison',
    't_landlord_tenant_split': 'IT Landlord/Tenant split',
    't_scope_breakdown': 'IT Scope breakdown',
    't_scope1_landlord': 'IT Scope 1 (Landlord)',
    't_scope2_landlord': 'IT Scope 2 (Landlord)',
    't_scope3_tenant': 'IT Scope 3 (Tenant)',
    't_scope1': 'IT Scope 1',
    't_scope2': 'IT Scope 2',
    't_scope3': 'IT Scope 3',
    't_net_change': 'IT Net change',
    't_required_asset_ref': 'IT Asset Reference *',
    't_impact_type': 'IT Impact (Type) *',
    't_gresb_efficiency_measure': 'IT GRESB Efficiency Measure',
    't_required_status': 'IT Status *',
    't_action_plan_title': 'IT Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'IT Area Covered *',
    't_required_currency': 'IT Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'IT Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'IT Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'IT Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'IT Secondary Utility Type',
    't_secondary_utility_change': 'IT Secondary Utility Change',
    't_required_action_id': 'IT Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'IT Active / inactive',
    't_required_meter_pan': 'IT Meter name  / MPAN *',
    't_required_meter_id': 'IT Meter ID *',
    't_required_from_date': 'IT From date *',
    't_required_to_date': 'IT To date *',
    't_required_consumption': 'IT Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'IT Estimated/actual *',
    't_required_origin': 'IT Origin *',
    't_scheduled_date': 'IT Scheduled date',
    't_estimated_change': 'IT Estimated change',
    't_find_action': 'IT Find action',
    't_filters': 'IT Filters',
    't_btn_request_consumption': 'IT Request consumption',
    't_header_request_consumption': 'IT Request Consumption',
    't_additional_information': 'IT Additional Information',
    't_serial_number_consumption': 'IT Serial Number',
    't_utility_type_consumption': 'IT Utility Type',
    't_area_covered_consumption': 'IT Area Covered',
    't_meter_status': 'IT Meter Status',
    't_submeter': 'IT Submeter',
    't_all_categories': 'IT All categories',
    't_estimated_data': 'IT Estimated data',
    't_delete_record': 'IT Delete record',
    't_delete_records': 'IT Delete records',
    't_edit_record': 'IT Edit record',
    't_edit_records': 'IT Edit records',
    't_add_consumptions': 'IT Add consumption',
    't_asset_procurement_data_categories': 'IT <p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'IT Recipients (separate emails with commas)',
    't_request_email_placeholder': 'IT Add email recipients',
    't_request_send_button': 'IT Send request email',
    't_email_sent_confirmation': 'IT Email sent',
    't_select_utility': 'IT Select Utility',
    't_utilities': 'IT Utilities',
    't_clear_all': 'IT Clear all',
    't_select_status': 'IT Select status',
    't_select_impact': 'IT Select impact',
    't_select_cost_type': 'IT Select cost type',
    't_select_scope': 'IT Select scope',
    't_select_procurement': 'IT Select procurement',
    't_search_meter_placeholder': 'IT Search meter name...',
    't_no_meter_data_available': 'IT This meter has no data available within the specified time frame',
    't_select_all': 'IT Select All',
    't_error_title': 'IT Error',
    't_delete_warn': 'IT Are you sure you want to delete this record?',
    't_delete_warn_s': 'IT Are you sure you want to delete these records?',
    't_delete_yes': 'IT Yes, delete',
    't_cancel_delete': 'IT No, cancel',
    't_no_export_data_available_for_single_asset': 'IT The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'IT Origin',
    't_submitted_by': 'IT Submitted by',
    't_gap_filled_scope': 'IT gap-filled',
    't_procured_data': 'IT procured data',
    't_meter_submitted_by': 'IT Submitted By',
    't_action_plan_improvement_sub_text': 'IT Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'IT Net Zero Carbon module not available.',
    't_action_details': 'IT Action details',
    't_action_details_description': 'IT Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_estimated_actual_required': 'IT Estimated or Actual *',
    't_action_information': 'IT Action information',
    't_action_title': 'IT Action title',
    't_action_impact_error_message': 'IT Please select a impact',
    't_action_title_error_message': 'IT Please select a title',
    't_action_status_error_message': 'IT Please select a status',
    't_current_consumption_with_gapFilled': 'IT Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'IT Previous period consumption ({0})',
    't_consumption_information': 'IT Consumption Information',
    't_add_consumption_title': 'IT Add Consumption',
    't_edit_record_title': 'IT Edit Record',
    't_edit_records_title': 'IT Edit Records',
    't_update_record': 'IT Update Record',
    't_update_records': 'IT Update Records',
    't_update_record_confirmation': 'IT Record updated',
    't_update_records_confirmation': 'IT Records updated',
    't_submit_consumption': 'IT Submit consumption',
    't_submit_confirmation': 'IT Consumption added',
    't_associated_costs_utility': 'IT Associated costs and Utility',
    't_associated_costs_utility_desc': 'IT The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'IT Cost of action',
    't_select_currency': 'IT Select currency',
    't_action_currency_error_message': 'IT Please select a currency',
    't_action_title_error_msg': 'IT Please add a title',
    't_nodata_for_timeperiod': 'IT There is no data available for this time period',
    't_back_to_list': 'IT Back to List',
    't_add_data': 'IT Add Data',
    't_edit_data': 'IT Edit Data',
    't_select_area_covered': 'IT Select area covered',
    't_action_area_covered_error_message': 'IT Please select the area covered',
    't_gresb_efficiency_measure_select': 'IT Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'IT Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'IT Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'IT On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'IT Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'IT Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'IT Social media / Online platform',
    't_tenant_meetings_which_includes': 'IT Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'IT Tenant sustainability events',
    't_tenant_sustainability_guide': 'IT Tenant sustainability guide',
    't_tenant_sustainability_training': 'IT Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'IT Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split': 'IT Gap-filled',
    't_action_scheduled_completion_date': 'IT Scheduled completion date',
    't_action_completion_date': 'IT Completion date',
    't_select_primary_utility': 'IT Select primary utility',
    't_select_secondary_utility': 'IT Select secondary utility',
    't_primary_utility': 'IT Primary utility',
    't_secondary_utility': 'IT Secondary utility',
    't_primary_utility_error_message': 'IT Please select a primary utility',
    't_primary_utility_cost_error_msg': 'IT Please enter a change',
    't_choose_breakdown': 'IT Choose breakdown',
    't_modified_date': 'IT Modified date',
    't_gap_filling': 'IT Gap-filling',
    't_sold_badge_label': 'IT Sold in',
    't_view_detailed_dq_break_down': 'IT View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'IT GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'IT Asset Name *',
    't_purchased': 'IT Purchased',
    't_nzc_sold': 'IT Sold',
    't_edit_asset': 'IT Edit asset',
    't_back_action_plan': 'IT Back to Action Plan',
    't_key_metrics': 'IT Key Metrics',
    't_payback_period': 'IT Payback period',
    't_matched_assets_count': 'IT {0} assets selected, please match the remaining assets',
    't_search_by_asset': 'IT Search by asset name',
    't_select_available_match': 'IT Select from {0} available matches',
    't_fund_sfdr_pai_report': 'IT SFDR PAI Report',
    't_y_o_y_trend': 'IT Year-on-Year Trend',
    't_adverse_sustainability_impact': 'IT Adverse Sustainability Impact',
    't_tonnes_co2e': 'IT tonnes CO2e',
    't_ghg_scope1': 'ITScope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'IT Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'IT Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'IT Total GHG emissions generated by real estate assets',
    't_including_estimates': 'IT Including estimates',
    't_actual_only': 'IT Actual Only',
    't_percentage': 'IT Percentage',
    't_vertical': 'IT Vertical',
    't_horizontal': 'IT Horizontal',
    't_fossil_fuels': 'IT Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'IT GHG emissions by scope',
    't_gia_tooltip_content': 'IT This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'IT This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'IT This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'IT This is the area associated with external areas such as car parks.',
    't_effect_on_utilities': 'IT Effect on utilities',
    't_single_year': 'IT year',
    't_multiple_years': 'IT years',
    't_gia_nla_required_message': 'IT Please ensure at least one field (GIA or NLA) is filled in',
    't_gia_nla_cpa_ext_length_validation_message': 'IT Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'IT Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'IT Please enter a date',
    't_future_year_error':'IT The year built can not be in the future',
    't_past_year_error' :'IT Year Built should be greater than 1800',
    't_invalid_year_error':'IT Invalid year format. Please enter a valid year',
    't_future_date_error': 'IT Date cannot be in the future',
    't_sale_date_error': 'IT Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'IT Please enter the purchase date',
    't_post_note': 'IT Post a note',
    't_clear_note': 'IT Clear note',
    't_higher_than_target': 'IT higher than target',
    't_lower_than_target': 'IT lower than target',
    't_higher_than_previous_period': 'IT higher than previous period',
    't_lower_than_previous_period': 'IT lower than previous period',
    't_date_created': 'IT Date created',
    't_created_by': 'IT Created by',
    't_gresb_sector_tooltip': 'IT Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'IT Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': 'IT {dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': 'IT {dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown': 'IT Please select an option from the dropdown',
    't_sync_success_message': 'IT Sync complete',
    't_notes_in_actions_not_saved': 'IT Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'IT Select the country of the asset',
    't_select_the_region_of_asset': 'IT Select the region of the asset',
    't_enter_asset_name': 'IT Please Enter Asset Name',
    't_validation_asset_name': 'IT Asset name already exists. Choose a different name',
    't_validation_asset_reference': 'IT Asset reference already exists. Choose a different reference',
    't_enter_asset_reference': 'IT Please Enter Asset Reference',
    't_select_assetdetails_fund': 'IT Select a fund',
    't_asset_ownership_invalid_input': 'IT Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required': 'IT Please enter a Fund Ownership %',
    't_asset_ownership_min_value': 'IT Range should be between 1-100',
    't_asset_ownership_max_value': 'IT Range should be between 1-100',
    't_documents': 'IT Documents',
    't_pai_selection': 'IT PAI selection',
    't_real_estate_mandatory': 'IT Mandatory for Real Estate',
    't_select_at_least': 'IT Select at least one from below',
    't_operational_control_asset': 'IT Select the Operational Control for the asset',
    't_select_at_least_one_option': 'IT Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'IT Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'IT Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'IT Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation': 'IT Enter the date of this last evaluation',
    't_keyfacts': 'IT Key Facts',
    't_performance_overview': 'IT Performance overview',
    't_variance_against_target': 'IT Variance against target',
    't_variance_against_previous_period': 'IT Variance against previous period',
    't_below': 'IT below',
    't_above': 'IT above',
    't_gap_filled_data_not_applicable': 'IT gap-filled data not applicable',
    't_documents_n_certificates': 'IT Documents & Certificates',
    't_consumption_evidence': 'IT Consumption Evidence',
    't_filter_applied': 'IT {0} filter applied.',
    't_filters_applied': 'IT {0} filters applied.',
    't_download_documents': 'IT Download documents',
    't_top_down_pathways': 'IT Top-Down pathways',
    't_upload_top_down_pathways': 'IT Upload top-down pathways',
    't_pai_report': 'IT PAI Report',
    't_fossil_fuel_impact_report': 'IT Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'IT Energy Efficiency Impact Report',
    't_ghg_impact_report': 'IT GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'IT Energy Consumption Impact Report',
    't_waste_impact_report': 'IT Waste Management Impact Report',
    't_resource_consumption_impact_report': 'IT Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'IT Biodiversity Impact Report',
    't_quarterly_summary': 'IT Quarterly Summary',
    't_exposed_value': 'IT Exposed Value',
    't_total_applicable_value': 'IT Total Applicable Value',
    't_total_excluded_value': 'IT Total Excluded Value',
    't_share_applicable_value_exposed': 'IT Share of applicable value exposed',
    't_share_total_value_excluded': 'IT Share of total value excluded',
    't_principle_metrics': 'IT Principle Metrics',
    't_average_share_exposed_value': 'IT Average share of exposed value',
    't_average_share_total_value_excluded': 'IT Average share of total value excluded',
    't_ped_below_nzeb': 'IT PED below NZEB?',
    't_total_portfolio_value': 'IT Total Portfolio Value',
    't_construction_year': 'IT Construction Year',
    't_total_scope1_emissions': 'IT Total Scope 1 Emissions',
    't_total_scope2_emissions': 'IT Total Scope 2 Emissions',
    't_total_scope3_emissions': 'IT Total Scope 3 Emissions',
    't_total_ghg_emissions': 'IT Total GHG Emissions',
    't_actual_data_only': 'IT Actual data only',
    't_including_estimations': 'IT Including estimations',
    't_exposed_value_share': 'IT Share of exposed value',
    't_inefficient_re': 'IT Inefficient RE',
    't_overview': 'IT Overview',
    't_ghg': 'IT GHG',
    't_ghg_emissions': 'IT GHG Emissions',
    't_total_contributing_area': 'IT Total contributing area',
    't_total_raw_material_usage': 'IT Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'IT Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'IT Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'IT Horizontal AArtificialisation',
    't_vertical_artificialization': 'IT Vertical Artificialisation',
    't_coverage_by_floorArea': 'IT Coverage by floor area',
    't_filename': 'IT File Name',
    't_document_type': 'IT Document Type',
    't_implementation_date': 'IT Implementation Date',
    't_date_of_upload': 'IT Date of Upload',
    't_uploaded_by': 'IT Uploaded by',
    't_fundname': 'IT Fund Name',
    't_document_size': 'IT Document Size',
    't_export_documents': 'IT Export documents',
    't_validation_errors': 'IT Record has validation errors',
    't_validation_warning': 'IT Record has warnings',
    't_validation_consumption_blank': 'IT Please enter consumption for this date range.',
    't_validation_consumption_specific': 'IT Please specify whether this consumption is estimated or actual.',
    't_validation_source': 'IT Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank': 'IT Please enter from date.',
    't_validation_to_date_blank': 'IT Please enter to date.',
    't_validation_comment': 'IT This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed': 'IT SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive': 'IT You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period': 'IT This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period': 'IT The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today': 'IT As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser': 'IT From date should be less than or equal to To date.',
    't_validation_date_overlap': 'IT We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'IT Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'IT You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'IT Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'IT Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'IT Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'IT When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'IT Actions breakdown',
    't_filenames': 'IT File Name(s)',
    't_metername': 'IT Meter Name',
    't_select_the_status_of_asset': 'IT Please select a status for this asset.',
    't_to_tc': 'IT To',
    't_delete_document': 'IT Delete document',
    't_confirm_delete_document': 'IT Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'IT Are you sure you want to delete these documents?',
    't_top_down_carbon_intensity': 'IT Top-Down Carbon intensity',
    't_top_down_energy_intensity': 'IT Top-Down Energy intensity',
    't_top_down_pathways_template_filename': 'IT Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title': 'IT Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title': 'IT Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template': 'IT How to use this template',
    't_pathway_name': 'IT Pathway Name',
    't_pathway':'IT Pathway',
    't_top_down_template_instruction_1': 'IT This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2': 'IT This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3': 'IT You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4': 'IT The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5': 'IT You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6': 'IT You must enter numerical values in these cells.',
    't_top_down_template_instruction_7': 'IT Please make sure you know the units you are using from Siera.',
    't_previous_period_recycled': 'IT previous period (recycled)',
    't_sustainable_weight_greater_than_total_weight': 'Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'IT Start date must be before end date',
    't_total_missing_data': 'IT total missing data',
    't_filter_documents': 'IT Filter documents',
    't_filter_consumption_evidence': 'IT Filter consumption evidence',
    't_valid_within': 'IT Valid within',
    't_evidence_date_range': 'IT Evidence date range',
    't_pick_date_range': 'IT Pick a date range',
    't_pick_evidence_date_range': 'IT Pick evidence date range',
    't_doc_type': 'IT Document type',
    't_select_doc_type': 'IT Select document type',
    't_select_doc_fund': 'IT Select fund',
    't_select_asset': 'IT Select asset',
    't_select_doc_country': 'IT Select country',
    't_select_managing_agent': 'IT Select managing agent',
    't_select_user': 'IT Select user',
    't_search_fund': 'IT Search by fund name',
    't_search_asset': 'IT Search by asset name or asset ref',
    't_search_name': 'IT Search by name',
    't_search_document': 'IT Search by document name',
    't_search_country': 'IT Search by country name',
    't_select_meter': 'IT Select meter',
    't_search_meter': 'IT Search meter',
    't_search_sector': 'IT Search sector',
    't_assurance_doc': 'IT Assurance document',
    't_audit_report': 'IT Audit/Recommendations report',
    't_energy_rating_certificate': 'IT Energy rating certificate',
    't_fund_report': 'IT Fund reports',
    't_green_building_certificate': 'IT Green building certificate',
    't_sustainability_action_plan': 'IT Sustainability action plan',
    't_select_a_status': 'IT Select a status',
    't_remove_item': 'IT Remove item',
    't_add_new_record': 'IT Add new record',
    't_add_old_record': 'IT Add old record',
    't_select_date_error': 'IT Please select a date',
    't_date_set_automatically': 'IT This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'IT Present',
    't_exposed': 'IT Exposed',
    't_not_exposed': 'IT Not exposed',
    't_renewable_energy_certificate':'IT Renewable energy certificate',
    't_expiry_date':'IT Expiry date',
    't_select_expiry_date':'IT Select expiry date',
    't_report_date':'IT Report date *',
    't_select_report_date':'IT Select a valid report date',
    't_record_type_document':'IT Which record type does this document belong to? *',
    't_select_record_type':'IT Select record type',
    't_select_document_type':'IT Select document type',
    't_drag_drop':'IT Drag and drop or',
    't_document_select_file':'IT Select file',
    't_document_export':'IT Document Export',
    't_add_document':'IT Add document',
    't_search_fund_ref':'IT Search by fund name',
    't_delete_top_down_pathway': 'IT Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'IT Are you sure you want to delete this top-down pathway?',
    't_exposure':'IT Exposure',
    't_contract_status': 'IT Contract status',
    't_active': 'IT Active',
    't_inactive': 'IT Inactive',
    't_saved':'IT Saved',
    't_document_upload':'IT Document upload *',
    't_asset_reference_address': 'IT Asset Reference & Address',
    't_clear_filters':'IT Clear filters',
    't_variance_previous_period_or_target':'IT Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'IT Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'IT GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'IT Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'IT Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': 'IT {fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': 'IT {areas} cannot be empty.',
    't_top_down_pathway_success_message_one' : 'IT {0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : 'IT {0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'IT Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'IT Return to Net Zero Carbon',
    't_save_document':'IT Save document',
    't_save_documents':'IT Save documents',
    't_edit_document':'IT Edit document',
    't_add_another_document':'IT Add another document',
    't_variance_explanation_title': 'IT Variance explanation',
    't_variance_explanation': 'IT Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'IT New document',
    't_update_document':'IT Update document',
    't_update_documents':'IT Update documents',
    't_document_updated':'IT Updated',
    't_target_variance': 'IT Target variance',
    't_period_variance': 'IT Period variance',
    't_landlord_data':'IT Landlord Data',
    't_tenant_procurement':'IT Tenant Procurement',
    't_planning_permission_before_year_built':'IT Planning Permission Date must be before the Year built.',
    't_impact_info': 'IT What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'IT Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'IT Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'IT Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'IT Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'IT The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'IT Utility consumption per year',
    't_utility_cost_year': 'IT Utility cost per year',
    't_utility_consumption_year_info': 'IT <info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': 'IT <info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'IT Tenant controlled',
    't_landlord_controlled': 'IT Landlord controlled',
    't_cannot_be_empty':'IT This field cannot be empty',
    't_add_asset_success': 'IT Asset has been created',
    't_add_asset_summary': 'IT Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'IT Asset has been updated',
    't_edit_asset_summary': 'IT Updates across all modules will be reflected shortly.',
    't_select_framework': 'IT Select a framework',
    't_utility_per_year': 'IT Utility per year',
    't_cost_per_year': 'IT Cost per year',
    't_utility_per_year_info_content_one': 'IT 1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': 'IT -1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': 'IT {0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': 'IT -{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'IT Year {year}',
    't_ped_tooltip_content': 'IT An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'IT The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'IT Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'IT The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'IT The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'IT The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'IT The total external, vertical surface area of the asset.',
    't_click_to_read': 'IT Click here to read more',
    't_reporting_years': 'IT Reporting Years',
    't_data_readiness': 'IT Data Readiness',
    't_waste_contract_status': 'IT Waste Contract Status',
    't_evaluation_date': 'IT Evaluation Date',
    't_add_new_status': 'IT Add new status',
    't_add_historic_status': 'IT Add historic status',
    't_add_new_exposure': 'IT Add new exposure',
    't_add_historic_exposure': 'IT Add historic exposure',
    't_siera_version': 'IT SIERA version',
    't_renewables': 'IT Renewables',
    't_on_site_generation': 'IT On-site generation',
    't_gia_percentage': 'IT {0}% of your GIA {1}',
    't_assets_count': 'IT {0} assets',
    't_self_consumption': 'IT {0}% Self consumption',
    't_export_to_grid': 'IT {0}% Exported to grid',
    't_contribution_electricity_consumption': 'IT {0}% Contribution to electricity consumption',
    't_on_site_generated': 'IT {0}% On site generated',
    't_off_site_purchased': 'IT {0}% Off-site purchased',
    't_non_renewables': 'IT {0}% Non-renewables',
    't_renewables_floor_area': 'IT Renewables floor area',
    't_renewables_floor_area_info': 'IT This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'IT Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'IT Which asset does this document belong to? *',
    't_valid_from_document':'IT Valid from date *',
    't_expiry_date_mandatory':'IT Expiry date *',
    't_end_date_after_start_date': 'IT End date must be after start date',
    't_action_deleted': 'IT Action successfully deleted',
    't_action_deleted_content': 'IT ‘{0}’ action has been deleted by {1}',
    't_select_agent': 'IT Select Agent',
    't_supplier_estimate': 'IT Supplier estimate',
    't_calculated_estimate': 'IT Calculated estimate',
    't_dq_total_asset_floor_area': 'IT Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'IT Floor area unaccounted for',
    't_action_name_exists': 'IT Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'ITManaging Agent',
    't_data_coverage' : 'IT Data coverage',
    't_data_completeness': 'IT Data completeness',
    't_fund_data_coverage': '<p><b>IT Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>IT Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'IT Add new Evaluation',
    't_add_new_occupancy': 'IT Add new Occupancy',
    't_documents_space_exceed':'IT You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'IT Data Category',
    't_supplier': 'IT Supplier',
    't_area_served': 'IT Floor Area Served',
    't_add_consumption': 'IT Add consumption',
    't_all_data_categories': 'IT All data categories',
    't_agreed_actions_count_nzc':'IT {0} Agreed actions',
    't_applicable_actions_count_nzc':'IT {0} Applicable actions',
    't_stranding_year_year': 'IT {0} (CRREM Misalignment year)',
    't_not_stranding': 'IT Not CRREM Misaligned',
    't_actions_pathway_recommended': 'IT Actions pathway (recommended)',
    't_actions_pathway_optional': 'IT Actions pathway (optional)',
    't_agreed_actions_pathway': 'IT Agreed actions pathway',
    't_applicable_actions_pathway': 'IT Applicable actions pathway',
    't_bau_pathway': 'IT Business as usual pathway',
    't_fund_view': 'IT Fund view',
    't_assets_list': 'IT Assets list',
    't_chart_specification': 'IT Chart specification',
    't_chart_preconfigured': 'IT This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- IT Grid decarbonisation',
    't_sbt_toast': '- IT Science based target (1.5C)',
    't_bau_toast': '- IT Business as Usual',
    't_agreed_actions_toast': '- IT Agreed Action based pathways',
    't_reporting_year_value': 'IT Reporting year: {0}',
    't_cost_intensity_value': 'IT {0} GBP/m²/yr',
    't_energy_intensity_value': 'IT {0} kWh/m²/yr',
    't_carbon_intensity_value': 'IT {0} kgCO₂e/m²/yr',
    't_co2_emissions_value': 'IT {0} tCO₂e/yr',
    't_data_coverage_percentage_value' : 'IT {0}% Data coverage',
    't_origin_meter_reading': 'IT Meter reading',
    't_origin_invoice': 'IT Invoice',
    't_origin_amr': 'IT AMR',
    't_actual_data': 'IT Actual data',
    'jv_between_funds': 'IT Joint venture between funds:',
    't_meter_inactive_sold': 'IT Meter was inactive or asset was not owned during this month',
    't_coverage': 'IT Coverage',
    't_completeness': 'IT Completeness',
    't_total_asset_floor_gia': 'IT Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'IT Expiry date must be after report date',
    't_unique_file_name': 'IT A file with this name already exists',
    't_special_character': 'IT File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'IT Comment can\'t contain special characters',
    't_custom': 'IT Custom'
  }
}